import React from "react";

export default function CloudInfraImg(props) {
  const theme = props.theme;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 3000 3000"
      width="550"
      height="550"
    >
      <path
        // fill="#ffffff"
        // fill={theme.imageDark}
        fill="rgba(0, 0, 0, 0)"
        d="M0 0h3000v3000H0z"
        // class="colorFFF svgShape"
      ></path>
      <path
        // fill="#353640"
        fill={theme.imageDark}
        d="M1919.891 2199.045h-.154a2.086 2.086 0 0 1 0-4.17h.154a2.086 2.086 0 0 1 0 4.17zm-12.798 0h-8.376a2.086 2.086 0 0 1 0-4.17h8.376a2.086 2.086 0 0 1 0 4.17zm-20.939 0h-8.355a2.086 2.086 0 0 1 0-4.17h8.355a2.086 2.086 0 0 1 0 4.17zm-20.896 0h-8.347a2.086 2.086 0 0 1 0-4.17h8.347a2.086 2.086 0 0 1 0 4.17zm-20.878 0h-8.344a2.086 2.086 0 0 1 0-4.17h8.344a2.086 2.086 0 0 1 0 4.17zm-20.87 0h-8.341a2.086 2.086 0 0 1 0-4.17h8.341a2.086 2.086 0 0 1 0 4.17zm-20.863 0h-8.341a2.086 2.086 0 0 1 0-4.17h8.341a2.086 2.086 0 0 1 0 4.17zm-20.859 0h-8.339a2.086 2.086 0 0 1 0-4.17h8.339a2.086 2.086 0 0 1 0 4.17zm-20.857 0h-8.338a2.086 2.086 0 0 1 0-4.17h8.338a2.086 2.086 0 0 1 0 4.17zm-20.855 0h-8.337a2.086 2.086 0 0 1 0-4.17h8.337a2.086 2.086 0 0 1 0 4.17zm-20.852 0h-8.337a2.086 2.086 0 0 1 0-4.17h8.337a2.086 2.086 0 0 1 0 4.17zm-20.851 0h-8.337a2.086 2.086 0 0 1 0-4.17h8.337a2.086 2.086 0 0 1 0 4.17zm-20.852 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.849 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.848 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.846 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.848 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.847 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.846 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.846 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.848 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.847 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.844 0h-8.371a2.086 2.086 0 0 1 0-4.17h8.371a2.086 2.086 0 0 1 0 4.17zm-20.913 0h-8.347a2.086 2.086 0 0 1 0-4.17h8.347a2.086 2.086 0 0 1 0 4.17zm-20.853 0h-8.322a2.086 2.086 0 0 1 0-4.17h8.322a2.086 2.086 0 0 1 0 4.17zm-20.795 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.847 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.846 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.847 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.848 0h-8.335a2.086 2.086 0 0 1 0-4.17h8.335a2.086 2.086 0 0 1 0 4.17zm-20.847 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.849 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.849 0h-8.336a2.086 2.086 0 0 1 0-4.17h8.336a2.086 2.086 0 0 1 0 4.17zm-20.85 0h-8.337a2.086 2.086 0 0 1 0-4.17h8.337a2.086 2.086 0 0 1 0 4.17zm-20.851 0h-8.337a2.086 2.086 0 0 1 0-4.17h8.337a2.086 2.086 0 0 1 0 4.17zm-20.852 0h-8.337a2.086 2.086 0 0 1 0-4.17h8.337a2.086 2.086 0 0 1 0 4.17zm-20.855 0h-8.338a2.086 2.086 0 0 1 0-4.17h8.338a2.086 2.086 0 0 1 0 4.17zm-20.856 0h-8.339a2.086 2.086 0 0 1 0-4.17h8.339a2.086 2.086 0 0 1 0 4.17zm-20.858 0h-8.34a2.086 2.086 0 0 1 0-4.17h8.34a2.086 2.086 0 0 1 0 4.17zm-20.863 0h-8.342a2.086 2.086 0 0 1 0-4.17h8.342a2.086 2.086 0 0 1 0 4.17zm-20.868 0h-8.344a2.086 2.086 0 0 1 0-4.17h8.344a2.086 2.086 0 0 1 0 4.17zm-20.876 0h-8.348a2.086 2.086 0 0 1 0-4.17h8.348a2.086 2.086 0 0 1 0 4.17zm-20.848-.151-.073-.001a237.337 237.337 0 0 1-8.388-.436 2.086 2.086 0 0 1-1.935-2.226 2.09 2.09 0 0 1 2.226-1.935c2.703.189 5.475.333 8.239.428a2.086 2.086 0 0 1-.069 4.17zm-20.731-1.653a2.2 2.2 0 0 1-.267-.017 203.634 203.634 0 0 1-8.313-1.238 2.086 2.086 0 0 1 .701-4.111c2.661.454 5.4.862 8.141 1.213a2.085 2.085 0 0 1-.262 4.153zm-20.447-3.733c-.162 0-.327-.02-.491-.06a170.472 170.472 0 0 1-8.133-2.175 2.085 2.085 0 1 1 1.176-4c2.584.76 5.254 1.475 7.935 2.122a2.085 2.085 0 0 1-.487 4.113zm-19.855-6.13c-.247 0-.499-.045-.744-.139a148.882 148.882 0 0 1-7.79-3.229 2.084 2.084 0 1 1 1.705-3.805 147.396 147.396 0 0 0 7.573 3.139 2.085 2.085 0 0 1-.744 4.034zm-18.829-8.778a2.08 2.08 0 0 1-1.016-.265 137.1 137.1 0 0 1-7.24-4.345 2.084 2.084 0 0 1-.626-2.881 2.082 2.082 0 0 1 2.881-.627 132.714 132.714 0 0 0 7.021 4.212 2.086 2.086 0 0 1-1.02 3.906zm-17.295-11.507c-.45 0-.903-.145-1.285-.444a133.465 133.465 0 0 1-6.479-5.423 2.085 2.085 0 1 1 2.777-3.111 129.223 129.223 0 0 0 6.276 5.253 2.085 2.085 0 0 1-1.289 3.725zm-15.286-14.075a2.081 2.081 0 0 1-1.528-.666 138.41 138.41 0 0 1-5.558-6.363 2.086 2.086 0 0 1 3.223-2.647 134.621 134.621 0 0 0 5.39 6.172 2.085 2.085 0 0 1-1.527 3.504zm965.532-.943h-2.386a2.086 2.086 0 0 1 0-4.17h2.386a2.086 2.086 0 0 1 0 4.17zm-14.885 0h-8.329a2.086 2.086 0 0 1 0-4.17h8.329a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-1.396c-2.396 0-4.774-.079-7.067-.234a2.084 2.084 0 1 1 .282-4.16c2.2.148 4.483.225 6.786.225h1.396a2.086 2.086 0 0 1-.001 4.169zm-20.666-1.939c-.146 0-.294-.016-.442-.048a74.832 74.832 0 0 1-8.236-2.27 2.086 2.086 0 0 1 1.34-3.95 70.626 70.626 0 0 0 7.777 2.143 2.086 2.086 0 0 1-.439 4.125zm-19.372-7.314a2.07 2.07 0 0 1-1.036-.277 62.436 62.436 0 0 1-7.142-4.784 2.084 2.084 0 1 1 2.555-3.295 58.364 58.364 0 0 0 6.663 4.464 2.084 2.084 0 0 1-1.04 3.892zm-902.74-6.065a2.08 2.08 0 0 1-1.723-.908 153.06 153.06 0 0 1-4.567-7.101 2.085 2.085 0 0 1 3.568-2.158 147.641 147.641 0 0 0 4.441 6.905 2.085 2.085 0 0 1-1.719 3.262zm886.827-7.171a2.084 2.084 0 0 1-1.587-.73 69.176 69.176 0 0 1-5.148-6.866 2.085 2.085 0 1 1 3.485-2.291 64.907 64.907 0 0 0 4.836 6.449 2.086 2.086 0 0 1-1.586 3.438zm-897.367-10.773a2.087 2.087 0 0 1-1.865-1.15 170.594 170.594 0 0 1-3.596-7.627 2.085 2.085 0 1 1 3.813-1.686 168.916 168.916 0 0 0 3.509 7.441 2.084 2.084 0 0 1-1.861 3.022zm886.425-6.865a2.084 2.084 0 0 1-1.908-1.244 90.203 90.203 0 0 1-3.066-7.962 2.084 2.084 0 1 1 3.957-1.316 86.077 86.077 0 0 0 2.924 7.593 2.086 2.086 0 0 1-1.907 2.929zm-894.635-12.275a2.085 2.085 0 0 1-1.96-1.375 198.074 198.074 0 0 1-2.7-7.979 2.084 2.084 0 0 1 1.362-2.615 2.08 2.08 0 0 1 2.615 1.361c.829 2.632 1.718 5.26 2.643 7.811a2.086 2.086 0 0 1-1.96 2.797zm888.461-7.606a2.087 2.087 0 0 1-2.044-1.681c-.546-2.763-.992-5.59-1.326-8.403a2.084 2.084 0 0 1 1.824-2.316 2.078 2.078 0 0 1 2.316 1.825c.321 2.707.751 5.428 1.276 8.086a2.083 2.083 0 0 1-2.046 2.489zm-894.532-12.329a2.086 2.086 0 0 1-2.021-1.579 229.688 229.688 0 0 1-1.894-8.199 2.086 2.086 0 0 1 4.079-.865 226.2 226.2 0 0 0 1.86 8.05 2.084 2.084 0 0 1-2.024 2.593zm892.555-8.433a2.086 2.086 0 0 1-2.085-2.085v-8.329a2.086 2.086 0 0 1 4.17 0v8.329a2.086 2.086 0 0 1-2.085 2.085zm-896.7-12a2.085 2.085 0 0 1-2.057-1.76 254.998 254.998 0 0 1-1.171-8.331 2.084 2.084 0 0 1 1.813-2.325 2.087 2.087 0 0 1 2.326 1.813c.34 2.747.728 5.504 1.152 8.192a2.086 2.086 0 0 1-2.063 2.411zm896.7-8.83a2.086 2.086 0 0 1-2.085-2.085v-8.329a2.086 2.086 0 0 1 4.17 0v8.329a2.086 2.086 0 0 1-2.085 2.085zm-899.102-11.892a2.084 2.084 0 0 1-2.077-1.928c-.21-2.783-.379-5.609-.502-8.398a2.085 2.085 0 0 1 1.991-2.175c1.146-.061 2.125.841 2.175 1.991.122 2.746.288 5.527.495 8.268a2.086 2.086 0 0 1-2.082 2.242zm899.102-8.937a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.855-11.918h-.008a2.084 2.084 0 0 1-2.077-2.093c.011-2.865.07-5.692.177-8.403a2.082 2.082 0 0 1 2.165-2.001 2.085 2.085 0 0 1 2.002 2.165 236.088 236.088 0 0 0-.174 8.255 2.085 2.085 0 0 1-2.085 2.077zm899.855-8.913a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.329a2.086 2.086 0 0 1 4.17 0v8.329a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.329a2.086 2.086 0 0 1 4.17 0v8.329a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.899a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.901a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm899.122-8.929a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm899.122-8.93a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.086 2.086 0 0 1-2.085 2.085zm-899.122-11.9a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085z"
        class="color353640 svgShape"
      ></path>
      <path
        // fill="#eff3f7"
        fill={theme.skinColor}
        // fill={theme.imageDark}
        d="M1132.79 1448.04a95.731 95.731 0 0 1 22.8 9.46l17.11-17.12 35.399 35.4-17.109 17.12-39.59 16.399c-9.771-13.54-25.681-22.359-43.65-22.359-29.7 0-53.78 24.08-53.78 53.79 0 2.939.24 5.819.69 8.63l-39.59 16.399h-24.2v-50.06h24.2a95.22 95.22 0 0 1 9.449-22.811l-17.119-17.109 35.399-35.4 17.12 17.12a95.453 95.453 0 0 1 22.811-9.46v-24.2h50.06v24.201zm67.65 67.66h24.199v50.06h-24.189a96.02 96.02 0 0 1-9.46 22.801l17.109 17.12-35.399 35.399-17.12-17.13a95.659 95.659 0 0 1-22.79 9.46v24.2h-50.06v-24.2a95.628 95.628 0 0 1-22.801-9.45l-17.12 17.12-35.399-35.399 17.12-17.12 39.579-16.4c9.771 13.54 25.681 22.35 43.641 22.35 29.71 0 53.79-24.079 53.79-53.779 0-2.94-.24-5.82-.69-8.641l39.59-16.391z"
        class="colorEFF3F7 svgShape"
      ></path>
      <path
        // fill="#949899"
        d="M1134.02 1659.695h-52.529a2.086 2.086 0 0 1-2.085-2.085v-23.806a102.13 102.13 0 0 1-21.481-8.909l-16.839 16.839a2.085 2.085 0 0 1-2.948 0l-37.141-37.14a2.089 2.089 0 0 1 0-2.95l16.839-16.839a102.187 102.187 0 0 1-8.91-21.481H985.12a2.086 2.086 0 0 1-2.085-2.085v-52.53c0-1.151.934-2.085 2.085-2.085h23.797a102.998 102.998 0 0 1 8.909-21.48l-16.84-16.84a2.085 2.085 0 0 1 0-2.949l37.15-37.14a2.086 2.086 0 0 1 2.948 0l16.839 16.839a102.168 102.168 0 0 1 21.481-8.911v-23.805c0-1.151.934-2.085 2.085-2.085h52.529c1.151 0 2.085.934 2.085 2.085v23.805a102.145 102.145 0 0 1 21.482 8.911l16.839-16.839a2.085 2.085 0 0 1 2.948 0l37.14 37.14a2.085 2.085 0 0 1 0 2.948l-16.84 16.849a102.47 102.47 0 0 1 8.91 21.472h23.795c1.151 0 2.085.934 2.085 2.085v52.53a2.086 2.086 0 0 1-2.085 2.085h-23.795a101.9 101.9 0 0 1-8.909 21.482l16.838 16.838a2.089 2.089 0 0 1 0 2.95l-37.15 37.14a2.085 2.085 0 0 1-2.948 0l-16.839-16.839a102.186 102.186 0 0 1-21.472 8.909v23.806a2.081 2.081 0 0 1-2.082 2.085zm-50.445-4.17h48.359v-23.306c0-.942.632-1.768 1.542-2.014a97.942 97.942 0 0 0 23.412-9.713 2.086 2.086 0 0 1 2.515.332l16.486 16.486 34.202-34.191-16.485-16.485a2.087 2.087 0 0 1-.332-2.517 97.768 97.768 0 0 0 9.713-23.42 2.085 2.085 0 0 1 2.013-1.543h23.295v-48.36H1205a2.085 2.085 0 0 1-2.013-1.542 98.23 98.23 0 0 0-9.714-23.413 2.084 2.084 0 0 1 .333-2.514l16.486-16.495-34.191-34.191-16.486 16.485a2.084 2.084 0 0 1-2.515.333 97.975 97.975 0 0 0-23.422-9.714 2.085 2.085 0 0 1-1.543-2.013v-23.305h-48.359v23.305c0 .943-.633 1.768-1.543 2.013a97.999 97.999 0 0 0-23.421 9.714 2.086 2.086 0 0 1-2.515-.333l-16.486-16.486-34.202 34.191 16.485 16.486c.667.666.803 1.696.333 2.513a98.824 98.824 0 0 0-9.715 23.425 2.086 2.086 0 0 1-2.013 1.541h-23.295v48.36h23.305c.943 0 1.768.633 2.013 1.543a98.037 98.037 0 0 0 9.713 23.421 2.086 2.086 0 0 1-.333 2.516l-16.485 16.485 34.192 34.191 16.486-16.486a2.086 2.086 0 0 1 2.515-.332 97.883 97.883 0 0 0 23.421 9.713 2.086 2.086 0 0 1 1.543 2.014v23.306zm24.175-62.03c-32.265 0-58.515-26.254-58.515-58.525 0-32.265 26.25-58.515 58.515-58.515 32.271 0 58.524 26.25 58.524 58.515 0 32.271-26.253 58.525-58.524 58.525zm0-112.87c-29.966 0-54.345 24.379-54.345 54.345 0 29.972 24.379 54.355 54.345 54.355 29.971 0 54.354-24.384 54.354-54.355 0-29.966-24.383-54.345-54.354-54.345z"
        class="color949899 svgShape"
      ></path>
      <path
        fill="#7da3fb"
        d="M460.79 1992.28h391.75c24.09 0 43.79 19.71 43.79 43.8v247.94c0 24.09-19.7 43.8-43.79 43.8H460.79c-24.09 0-43.79-19.71-43.79-43.8v-247.94c0-24.09 19.7-43.8 43.79-43.8z"
        class="color7DA3FB svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M460.8 2033.6h220.67v17.35H460.8zM460.8 2080.71h136.37v17.35H460.8zM460.8 2127.82h168.6v17.35H460.8zM460.8 2174.93h218.19v17.35H460.8zM460.8 2222.04h247.94v17.35H460.8zM460.8 2269.149h139.68v17.351H460.8zM621.55 2269.149h139.67v17.351H621.55zM696.34 2174.93h121.49v17.35H696.34zM653.37 2127.82h64.46v17.35h-64.46zM738.49 2127.82h110.75v17.35H738.49z"
        class="colorFFF svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M852.54 2329.905H460.79c-42.733 0-45.845-45.307-45.872-45.765a2.403 2.403 0 0 1-.003-.12v-247.94a2.086 2.086 0 0 1 4.17 0v247.876c.154 2.396 3.295 41.779 41.705 41.779h391.75a2.086 2.086 0 0 1 0 4.17z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#353640"
        d="M389.41 1014.456a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.085 2.085 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.33a2.086 2.086 0 0 1 4.17 0v8.33a2.084 2.084 0 0 1-2.085 2.085zm0-20.83a2.086 2.086 0 0 1-2.085-2.085v-8.338a2.085 2.085 0 0 1 2.084-2.077h.009a2.086 2.086 0 0 1 2.077 2.093v8.322a2.084 2.084 0 0 1-2.085 2.085zm.52-20.806a2.085 2.085 0 0 1-2.08-2.257c.234-2.83.55-5.65.939-8.383a2.08 2.08 0 0 1 2.358-1.77 2.084 2.084 0 0 1 1.77 2.358c-.377 2.651-.684 5.39-.911 8.139a2.087 2.087 0 0 1-2.076 1.913zm3.269-20.499a2.085 2.085 0 0 1-2.028-2.579c.669-2.751 1.438-5.49 2.285-8.141a2.085 2.085 0 1 1 3.973 1.269 116.471 116.471 0 0 0-2.206 7.858 2.086 2.086 0 0 1-2.024 1.593zm6.689-19.639a2.086 2.086 0 0 1-1.902-2.939 108.396 108.396 0 0 1 3.768-7.589 2.086 2.086 0 0 1 3.66 2 104.41 104.41 0 0 0-3.622 7.296 2.086 2.086 0 0 1-1.904 1.232zm10.312-18.006a2.085 2.085 0 0 1-1.695-3.296 108.344 108.344 0 0 1 5.191-6.703 2.086 2.086 0 0 1 3.195 2.681 104.087 104.087 0 0 0-4.99 6.444 2.084 2.084 0 0 1-1.701.874zm13.654-15.653a2.084 2.084 0 0 1-1.434-3.598 117.66 117.66 0 0 1 6.359-5.6 2.084 2.084 0 1 1 2.642 3.226 113.797 113.797 0 0 0-6.133 5.4c-.404.383-.92.572-1.434.572zm16.304-12.91a2.085 2.085 0 0 1-1.155-3.823 137.646 137.646 0 0 1 7.194-4.452 2.084 2.084 0 1 1 2.085 3.611 133.89 133.89 0 0 0-6.975 4.316 2.068 2.068 0 0 1-1.149.348zm18.175-10.165a2.085 2.085 0 0 1-.887-3.973 163.203 163.203 0 0 1 7.738-3.386 2.084 2.084 0 1 1 1.573 3.861 158.832 158.832 0 0 0-7.54 3.3 2.07 2.07 0 0 1-.884.198zm19.391-7.642a2.086 2.086 0 0 1-.647-4.067c2.634-.86 5.352-1.681 8.078-2.439a2.085 2.085 0 0 1 1.117 4.017 187.546 187.546 0 0 0-7.901 2.385 2.055 2.055 0 0 1-.647.104zm20.154-5.387a2.086 2.086 0 0 1-.431-4.125 210.05 210.05 0 0 1 8.287-1.583 2.087 2.087 0 0 1 .7 4.112c-2.706.46-5.438.982-8.123 1.551a2.13 2.13 0 0 1-.433.045zm20.624-3.29a2.085 2.085 0 0 1-.219-4.158c3.724-.397 6.653-.596 8.455-.693 1.143-.056 2.132.82 2.194 1.97s-.82 2.132-1.97 2.194a158.87 158.87 0 0 0-8.237.676 2.378 2.378 0 0 1-.223.011zm1029.059-.794h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.829 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.829 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.829 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.829 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.829 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17H881a2.086 2.086 0 0 1 0 4.17zm-20.829 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.829 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17z"
        class="color353640 svgShape"
      ></path>
      <path
        fill="#d0d3d4"
        d="M1981.34 1998.95h505.83c14.37 0 26.13 11.76 26.13 26.13v26.13h-558.09v-26.13c0-14.37 11.76-26.13 26.13-26.13z"
        class="colorD0D3D4 svgShape"
      ></path>
      <path
        fill="#353640"
        d="M2000.21 2401.06h468.09c24.75 0 45-20.239 45-45v-304.85h-558.09v304.85c0 24.76 20.25 45 45 45z"
        class="color353640 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1955.21 2358.145a2.086 2.086 0 0 1-2.085-2.085v-304.85c0-1.151.934-2.085 2.085-2.085h403.18a2.086 2.086 0 0 1 0 4.17h-401.095v302.765a2.086 2.086 0 0 1-2.085 2.085z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#949899"
        d="M2388.38 2402.239h-381.53a1.18 1.18 0 0 1 0-2.36h381.53a1.18 1.18 0 0 1 0 2.36z"
        class="color949899 svgShape"
      ></path>
      <path
        fill="#a5c250"
        d="M2188.13 2094.455h-188.72a2.086 2.086 0 0 1 0-4.17h188.72a2.086 2.086 0 0 1 0 4.17z"
        class="colorA5C250 svgShape"
      ></path>
      <path
        fill="#fbcc7c"
        d="M2387.73 2143.814h-388.32a2.086 2.086 0 0 1 0-4.17h388.32a2.086 2.086 0 0 1 0 4.17zM2110.47 2193.165h-111.06a2.086 2.086 0 0 1 0-4.17h111.06a2.086 2.086 0 0 1 0 4.17z"
        class="colorFBCC7C svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M2056.75 2242.525h-57.34a2.086 2.086 0 0 1 0-4.17h57.34a2.086 2.086 0 0 1 0 4.17z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#fbcc7c"
        d="M2074.9 2291.885h-75.49a2.086 2.086 0 0 1 0-4.17h75.49a2.086 2.086 0 0 1 0 4.17z"
        class="colorFBCC7C svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M2189.58 2341.234h-190.17a2.086 2.086 0 0 1 0-4.17h190.17a2.086 2.086 0 0 1 0 4.17zM2242.57 2291.885h-127.02a2.086 2.086 0 0 1 0-4.17h127.021a2.086 2.086 0 0 1-.001 4.17z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#fbcc7c"
        d="M2218.62 2242.525h-127.75a2.086 2.086 0 0 1 0-4.17h127.75a2.086 2.086 0 0 1 0 4.17z"
        class="colorFBCC7C svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M2314.061 2242.525h-57.341a2.086 2.086 0 0 1 0-4.17h57.341a2.086 2.086 0 0 1 0 4.17zM2421.12 2193.165H2159.1a2.086 2.086 0 0 1 0-4.17h262.021a2.086 2.086 0 0 1-.001 4.17z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#fbcc7c"
        d="M652.02 761.12h570.261c18.88 0 34.33 15.45 34.33 34.33v34.33H617.689v-34.33c0-18.88 15.451-34.33 34.331-34.33z"
        class="colorFBCC7C svgShape"
      ></path>
      <path
        fill="#eff3f7"
        d="M676.811 1289.42h520.67c32.52 0 59.13-26.6 59.13-59.12V829.78H617.689v400.52c0 32.52 26.601 59.12 59.122 59.12z"
        class="colorEFF3F7 svgShape"
      ></path>
      <path
        fill="#353640"
        d="m880.57 1143.83-149.83-65.101v-36.06l149.83-64.85v42.42l-104.52 39.981 104.521 41.5v42.11zm13.73 28.68 54.32-225.81h31.43l-54.62 225.81H894.3zm99.43-28.38v-42.109l104.51-41.24-104.51-40.84V978.13l149.829 64.9v35.8l-149.829 65.3z"
        class="color353640 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M617.689 1232.385a2.086 2.086 0 0 1-2.085-2.085V829.78c0-1.151.934-2.085 2.085-2.085h461.57a2.086 2.086 0 0 1 0 4.17H619.774V1230.3a2.085 2.085 0 0 1-2.085 2.085zM1113.59 1291.505H676.811a2.086 2.086 0 0 1 0-4.17h436.779a2.086 2.086 0 0 1 0 4.17z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#fbcc7c"
        d="M316.9 1773.25h176.57c7.83 0 14.24 6.4 14.24 14.24v102.53c0 7.829-6.41 14.229-14.24 14.229H316.9c-7.83 0-14.24-6.4-14.24-14.229v-102.53c0-7.84 6.41-14.24 14.24-14.24z"
        class="colorFBCC7C svgShape"
      ></path>
      <path
        fill="#ff845e"
        d="m302.66 1890.01 82.16-61.44 20.369 10.18z"
        class="colorFF845E svgShape"
      ></path>
      <path
        fill="#ff845e"
        d="m507.71 1890.01-82.16-61.44-20.361 10.18z"
        class="colorFF845E svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M405.189 1840.835c-.319 0-.639-.073-.932-.22l-102.529-51.26a2.086 2.086 0 0 1 1.864-3.731l101.597 50.794 101.588-50.794a2.084 2.084 0 1 1 1.865 3.731l-102.521 51.26c-.292.147-.612.22-.932.22z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M302.662 1892.095a2.086 2.086 0 0 1-1.25-3.755l82.16-61.439a2.085 2.085 0 0 1 2.497 3.34l-82.16 61.439c-.375.28-.813.415-1.247.415zM507.708 1892.095c-.435 0-.873-.135-1.247-.415l-82.16-61.439a2.085 2.085 0 0 1 2.497-3.34l82.16 61.439a2.085 2.085 0 0 1-1.25 3.755z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#7da3fb"
        d="m2467.89 1067.01-.03.04c-3.949 3.94-10.34 3.94-14.279 0-3.94-3.939-3.94-10.33 0-14.27 19.939-19.94 46.08-29.92 72.22-29.92 26.13 0 52.271 9.979 72.21 29.92 3.939 3.939 3.939 10.33 0 14.27-3.939 3.94-10.33 3.94-14.27 0-16-15.99-36.971-23.99-57.94-23.99-20.961 0-41.911 7.98-57.911 23.95zm57.91 54.02c7.57 0 13.71 6.149 13.71 13.72 0 7.58-6.14 13.72-13.71 13.72-7.58 0-13.72-6.14-13.72-13.72 0-7.57 6.14-13.72 13.72-13.72zm-21.76-2.59c-3.95 3.939-10.341 3.939-14.28 0-3.939-3.95-3.939-10.34 0-14.28 9.95-9.95 22.99-14.931 36.04-14.931 13.04 0 26.08 4.98 36.03 14.931 3.939 3.939 3.939 10.33 0 14.28-3.94 3.939-10.33 3.939-14.28 0-6-6.011-13.88-9.021-21.75-9.021-7.88.001-15.76 3.011-21.76 9.021zm-22.04-24.88c-3.94 3.94-10.33 3.94-14.28 0-3.94-3.939-3.94-10.329 0-14.27 16.04-16.04 37.06-24.061 58.08-24.061 21.01 0 42.03 8.021 58.07 24.061 3.939 3.939 3.939 10.33 0 14.27-3.94 3.94-10.33 3.94-14.28 0-12.09-12.09-27.939-18.14-43.79-18.14-15.861 0-31.71 6.05-43.8 18.14zM2343.58 1774.6c17.24-8.069 38.01-7.87 55.74 2.37 21.189 12.23 32.14 35.391 29.85 58.25l136.49 78.801c13.55-7.07 30.3-7.271 44.52.93 13.591 7.85 21.69 21.57 22.94 36.1l-30.97-17.87-13.2 7.62-13.21 7.63v30.5l30.96 17.87c-13.21 6.19-29.13 6.03-42.729-1.81-14.211-8.21-22.41-22.82-23.061-38.09l-136.5-78.801c-18.65 13.41-44.18 15.511-65.37 3.271-17.729-10.24-28.29-28.12-29.92-47.09l40.39 23.319 17.23-9.939 17.229-9.95v-39.79l-40.389-23.321z"
        class="color7DA3FB svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M2586.851 2001.64a51.348 51.348 0 0 1-25.603-6.873c-14.956-8.644-24.442-23.958-25.55-41.137l-143.258-82.708c-10.992 7.559-24.322 11.709-37.692 11.709-11.574 0-23.021-3.075-33.101-8.896-18.753-10.82-31.055-30.181-32.905-51.788a2.087 2.087 0 0 1 3.12-1.984l41.979 24.239 34.624-19.986v-39.973l-41.987-24.238a2.086 2.086 0 0 1 .158-3.695c8.788-4.114 18.553-6.289 28.235-6.289 11.564 0 23 3.075 33.072 8.892 22.148 12.788 34.977 37.29 32.952 62.717l143.259 82.709a51.703 51.703 0 0 1 22.792-5.323c8.955 0 17.81 2.382 25.606 6.888 14.508 8.365 24.027 23.348 25.464 40.077a2.087 2.087 0 0 1-3.12 1.984l-31.937-18.438-26.055 15.036.01 30.082 31.938 18.438a2.086 2.086 0 0 1-.159 3.695 51.857 51.857 0 0 1-21.842 4.862zm-194.521-135.275c.359 0 .719.093 1.043.279l145.39 83.939a2.085 2.085 0 0 1 1.04 1.717c.688 16.212 9.484 30.736 23.529 38.854a47.153 47.153 0 0 0 23.519 6.315c5.514 0 11.063-.99 16.261-2.885l-29.324-16.93a2.085 2.085 0 0 1-1.042-1.806l-.011-32.488a2.083 2.083 0 0 1 1.043-1.807l28.141-16.24a2.082 2.082 0 0 1 2.085 0l29.327 16.932c-2.393-13.698-10.729-25.733-22.862-32.729a47.067 47.067 0 0 0-23.521-6.33 47.508 47.508 0 0 0-21.892 5.372 2.094 2.094 0 0 1-2.008-.043l-145.39-83.939a2.084 2.084 0 0 1-1.031-2.014c2.432-24.276-9.646-47.842-30.769-60.037-9.438-5.451-20.153-8.333-30.986-8.333-7.715 0-15.485 1.474-22.702 4.284l39.423 22.758a2.083 2.083 0 0 1 1.043 1.806v42.38c0 .745-.397 1.433-1.042 1.806l-36.711 21.19a2.082 2.082 0 0 1-2.085 0l-39.417-22.761c2.833 18.596 13.963 35.012 30.352 44.469 9.448 5.454 20.174 8.337 31.017 8.337 12.956 0 25.87-4.156 36.364-11.703a2.074 2.074 0 0 1 1.216-.393z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#eff3f7"
        d="M289.65 1090.7h43.21v8.069c0 5.311 4.34 9.66 9.649 9.66h103.23c5.31 0 9.66-4.35 9.66-9.66v-8.069H498.6c18.2 0 33.08 14.89 33.08 33.08v492.649c0 18.2-14.88 33.09-33.08 33.09H289.65c-18.19 0-33.08-14.89-33.08-33.09V1123.78c0-18.19 14.89-33.08 33.08-33.08z"
        class="colorEFF3F7 svgShape"
      ></path>
      <path
        fill="#353640"
        d="M287.44 1144.94h213.371v12.03H287.44zM287.45 1193.89h213.361v12.03H287.45zM287.45 1242.84h213.361v12.03H287.45zM287.44 1291.78h213.371v12.03H287.44z"
        class="color353640 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M287.44 1484.42h213.371v-139.691H287.44z"
        class="colorFFF svgShape"
      ></path>
      <path
        fill="#d0d3d4"
        d="M500.811 1485.6H287.44a1.18 1.18 0 0 1-1.18-1.18v-139.69a1.18 1.18 0 1 1 2.36 0v138.51h212.19a1.18 1.18 0 0 1 .001 2.36z"
        class="colorD0D3D4 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M498.6 1651.605H289.65c-10.765 0-19.324-3.187-25.438-9.472-10.032-10.312-9.744-25.125-9.727-25.751v-492.603a2.086 2.086 0 0 1 4.17 0v492.66c-.004.19-.235 13.785 8.57 22.811 5.299 5.431 12.843 8.185 22.425 8.185H498.6a2.086 2.086 0 0 1 0 4.17z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M287.44 1543.67h213.371v12.03H287.44zM287.44 1592.08h213.371v12.03H287.44z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#353640"
        d="M2652.9 1142.245a2.086 2.086 0 0 1-2.085-2.085v-2.002a2.086 2.086 0 0 1 4.17 0v2.002a2.084 2.084 0 0 1-2.085 2.085zm0-14.583a2.086 2.086 0 0 1-2.085-2.085v-8.368a2.086 2.086 0 0 1 4.17 0v8.368a2.085 2.085 0 0 1-2.085 2.085zm0-20.916a2.086 2.086 0 0 1-2.085-2.085v-8.354a2.086 2.086 0 0 1 4.17 0v8.354a2.085 2.085 0 0 1-2.085 2.085zm0-20.892a2.086 2.086 0 0 1-2.085-2.085v-8.349a2.086 2.086 0 0 1 4.17 0v8.349a2.085 2.085 0 0 1-2.085 2.085zm0-20.88a2.086 2.086 0 0 1-2.085-2.085v-8.346a2.086 2.086 0 0 1 4.17 0v8.346a2.085 2.085 0 0 1-2.085 2.085zm0-20.875a2.086 2.086 0 0 1-2.085-2.085v-8.345a2.086 2.086 0 0 1 4.17 0v8.345a2.084 2.084 0 0 1-2.085 2.085zm0-20.871a2.086 2.086 0 0 1-2.085-2.085v-8.343a2.086 2.086 0 0 1 4.17 0v8.343a2.085 2.085 0 0 1-2.085 2.085zm0-20.869a2.086 2.086 0 0 1-2.085-2.085v-8.343a2.086 2.086 0 0 1 4.17 0v8.343a2.085 2.085 0 0 1-2.085 2.085zm0-20.868a2.086 2.086 0 0 1-2.085-2.085v-8.35a2.086 2.086 0 0 1 4.17 0v8.35a2.085 2.085 0 0 1-2.085 2.085zm0-20.845a2.086 2.086 0 0 1-2.085-2.085v-8.343a2.086 2.086 0 0 1 4.17 0v8.343a2.085 2.085 0 0 1-2.085 2.085zm0-20.87a2.086 2.086 0 0 1-2.085-2.085v-8.344a2.086 2.086 0 0 1 4.17 0v8.344a2.084 2.084 0 0 1-2.085 2.085zm0-20.872a2.086 2.086 0 0 1-2.085-2.085v-8.345a2.086 2.086 0 0 1 4.17 0v8.345a2.084 2.084 0 0 1-2.085 2.085zm0-20.875a2.086 2.086 0 0 1-2.085-2.085v-8.347a2.086 2.086 0 0 1 4.17 0v8.347a2.085 2.085 0 0 1-2.085 2.085zm0-20.883a2.086 2.086 0 0 1-2.085-2.085v-8.352a2.086 2.086 0 0 1 4.17 0v8.352a2.084 2.084 0 0 1-2.085 2.085zm0-20.894a2.086 2.086 0 0 1-2.085-2.085v-8.361a2.086 2.086 0 0 1 4.17 0v8.361a2.085 2.085 0 0 1-2.085 2.085zm-.001-20.915a2.086 2.086 0 0 1-2.085-2.079 93.067 93.067 0 0 0-.377-8.128 2.085 2.085 0 0 1 1.886-2.267 2.096 2.096 0 0 1 2.267 1.886c.253 2.76.386 5.618.395 8.496a2.084 2.084 0 0 1-2.078 2.091l-.008.001zm-2.435-20.618a2.085 2.085 0 0 1-2.022-1.586 72.086 72.086 0 0 0-2.368-7.728 2.086 2.086 0 0 1 3.912-1.447 76.889 76.889 0 0 1 2.505 8.175 2.086 2.086 0 0 1-2.027 2.586zm-7.776-19.22a2.087 2.087 0 0 1-1.798-1.025 66.319 66.319 0 0 0-4.516-6.682 2.086 2.086 0 0 1 3.307-2.541 70.632 70.632 0 0 1 4.801 7.103 2.084 2.084 0 0 1-1.794 3.145zm-13.123-16.06a2.079 2.079 0 0 1-1.4-.541 72.665 72.665 0 0 0-6.286-5.087 2.085 2.085 0 0 1 2.439-3.382 76.938 76.938 0 0 1 6.649 5.381 2.084 2.084 0 0 1-1.402 3.629zm-17.136-11.717a2.07 2.07 0 0 1-.942-.227 86.586 86.586 0 0 0-7.416-3.333 2.085 2.085 0 0 1 1.531-3.879 90.514 90.514 0 0 1 7.773 3.495 2.084 2.084 0 0 1-.946 3.944zm-19.491-7.217c-.168 0-.337-.02-.507-.063a99.425 99.425 0 0 0-7.99-1.646 2.086 2.086 0 0 1-1.721-2.394 2.089 2.089 0 0 1 2.395-1.721c2.804.458 5.605 1.036 8.326 1.715a2.085 2.085 0 0 1-.503 4.109zm-20.585-2.95c-.03 0-.06 0-.089-.002a101.132 101.132 0 0 0-4.233-.088h-4.01a2.086 2.086 0 0 1 0-4.17h4.01c1.465 0 2.948.031 4.407.092a2.085 2.085 0 0 1-.085 4.168zm-20.832-.09h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.831 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17zm-20.83 0h-8.33a2.086 2.086 0 0 1 0-4.17h8.33a2.086 2.086 0 0 1 0 4.17z"
        class="color353640 svgShape"
      ></path>
      <path
        fill="#fbcc7c"
        d="M1651.46 497.89h715.67c18.88 0 34.33 15.44 34.33 34.33v34.33h-784.33v-34.33c0-18.89 15.45-34.33 34.33-34.33z"
        class="colorFBCC7C svgShape"
      ></path>
      <path
        fill="#eff3f7"
        d="M1676.25 1026.19h666.08c32.52 0 59.13-26.601 59.13-59.131V566.55h-784.33v400.51c0 32.53 26.6 59.13 59.12 59.13z"
        class="colorEFF3F7 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1617.13 969.145a2.086 2.086 0 0 1-2.085-2.085V566.55c0-1.151.934-2.085 2.085-2.085h461.57a2.086 2.086 0 0 1 0 4.17h-459.485V967.06a2.086 2.086 0 0 1-2.085 2.085zM2225.89 1028.275h-536.18a2.086 2.086 0 0 1 0-4.17h536.18a2.086 2.086 0 0 1 0 4.17z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M2033.13 669.92h184.86v17.351h-184.86z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#353640"
        d="M2033.13 717.03h307.49v17.35h-307.49zM2033.13 764.14h307.49v17.35h-307.49zM2033.13 811.25h182.78v17.35h-182.78zM2033.13 858.36h307.49v17.35h-307.49zM2033.13 905.47h117.01v17.35h-117.01zM2230.439 811.25h110.181v17.35h-110.181z"
        class="color353640 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M1692.21 647.37h298v298h-298z"
        class="colorFFF svgShape"
      ></path>
      <path
        fill="#7da3fb"
        d="M1900.84 1208.05c0 29.4-11.93 56.04-31.199 75.32-19.281 19.27-45.91 31.2-75.32 31.2-29.4 0-56.04-11.931-75.32-31.2-19.27-19.28-31.199-45.92-31.199-75.32 0-27.64 10.539-52.83 27.81-71.76l25.39 23.15c-11.699 12.819-18.84 29.88-18.84 48.609 0 19.931 8.08 37.971 21.141 51.03 13.05 13.05 31.09 21.13 51.02 21.13s37.97-8.08 51.03-21.13c13.05-13.06 21.13-31.1 21.13-51.03h34.357v.001z"
        class="color7DA3FB svgShape"
      ></path>
      <path
        fill="#ff845e"
        d="M1794.32 1101.53c29.41 0 56.039 11.93 75.319 31.199 19.271 19.28 31.2 45.91 31.2 75.32h-34.359c0-19.93-8.08-37.97-21.131-51.02-13.06-13.061-31.1-21.141-51.029-21.141v-34.358z"
        class="colorFF845E svgShape"
      ></path>
      <path
        fill="#a5c250"
        d="m1433.33 700.69-59.141 75.35h30.781v74.54H1461.689v-74.54h34.841z"
        class="colorA5C250 svgShape"
      ></path>
      <path
        fill="#d0d3d4"
        d="M743.78 1413.45a64.596 64.596 0 0 1 15.34 6.359l11.51-11.51 23.811 23.8-11.511 11.521-26.63 11.03c-6.569-9.11-17.26-15.04-29.35-15.04-19.98 0-36.17 16.199-36.17 36.18 0 1.97.16 3.91.46 5.8l-26.62 11.03h-16.28v-33.67h16.271a64.523 64.523 0 0 1 6.359-15.33l-11.51-11.52 23.81-23.801 11.511 11.51a64.184 64.184 0 0 1 15.34-6.359v-16.271h33.66v16.271h-.001zm45.5 45.5h16.28v33.67h-16.27a64.484 64.484 0 0 1-6.36 15.33l11.511 11.51-23.811 23.811-11.52-11.511a64.46 64.46 0 0 1-15.33 6.36v16.27h-33.66v-16.27a64.557 64.557 0 0 1-15.34-6.36l-11.511 11.511-23.81-23.811 11.521-11.51 26.619-11.021c6.561 9.101 17.271 15.03 29.351 15.03 19.979 0 36.17-16.2 36.17-36.17 0-1.98-.16-3.92-.46-5.811l26.62-11.028z"
        class="colorD0D3D4 svgShape"
      ></path>
      <path
        fill="#949899"
        d="M744.61 1556.475h-35.32a2.086 2.086 0 0 1-2.085-2.085v-15.492a69.658 69.658 0 0 1-13.646-5.667l-10.963 10.973c-.782.783-2.167.782-2.949.001l-24.98-24.979a2.089 2.089 0 0 1 0-2.95l10.963-10.963a69.296 69.296 0 0 1-5.659-13.647h-15.5a2.086 2.086 0 0 1-2.085-2.085v-35.33c0-1.151.934-2.085 2.085-2.085h15.501a69.296 69.296 0 0 1 5.658-13.646l-10.962-10.954a2.087 2.087 0 0 1 0-2.95l24.98-24.979a2.085 2.085 0 0 1 2.948 0l10.963 10.963a69.15 69.15 0 0 1 13.647-5.659v-15.5c0-1.151.934-2.085 2.085-2.085h35.32c1.151 0 2.085.934 2.085 2.085v15.5a69.122 69.122 0 0 1 13.647 5.658l10.963-10.963c.781-.782 2.167-.783 2.948 0l24.979 24.979a2.085 2.085 0 0 1 0 2.948l-10.965 10.965a70.055 70.055 0 0 1 5.657 13.636h15.494c1.151 0 2.085.934 2.085 2.085v35.33a2.086 2.086 0 0 1-2.085 2.085h-15.491a69.04 69.04 0 0 1-5.659 13.647l10.955 10.964a2.085 2.085 0 0 1 0 2.947l-24.97 24.979a2.089 2.089 0 0 1-2.95 0l-10.963-10.973a69.683 69.683 0 0 1-13.646 5.667v15.492a2.086 2.086 0 0 1-2.085 2.088zm-33.235-4.17h31.15v-14.984c0-.942.632-1.768 1.541-2.013a65.479 65.479 0 0 0 15.593-6.475 2.083 2.083 0 0 1 2.516.333l10.605 10.614 22.021-22.03-10.598-10.606a2.087 2.087 0 0 1-.332-2.515 64.967 64.967 0 0 0 6.463-15.589 2.085 2.085 0 0 1 2.014-1.545h14.985v-31.16H792.35a2.085 2.085 0 0 1-2.013-1.541 65.929 65.929 0 0 0-6.465-15.586 2.084 2.084 0 0 1 .334-2.512l10.605-10.606-22.031-22.031-10.606 10.605a2.084 2.084 0 0 1-2.515.333 64.967 64.967 0 0 0-15.589-6.463 2.084 2.084 0 0 1-1.545-2.014v-14.995h-31.15v14.995c0 .943-.633 1.77-1.545 2.014a64.967 64.967 0 0 0-15.589 6.463 2.085 2.085 0 0 1-2.515-.333l-10.606-10.605-22.031 22.03 10.604 10.596c.667.667.804 1.698.333 2.516a65.183 65.183 0 0 0-6.463 15.591 2.085 2.085 0 0 1-2.014 1.543h-14.995v31.16h14.995c.943 0 1.769.633 2.014 1.544a65.031 65.031 0 0 0 6.463 15.589 2.086 2.086 0 0 1-.333 2.516l-10.605 10.605 22.031 22.03 10.605-10.614a2.085 2.085 0 0 1 2.516-.333 65.537 65.537 0 0 0 15.593 6.475 2.084 2.084 0 0 1 1.541 2.013v14.985zm15.575-40.35c-22.081 0-40.045-17.959-40.045-40.035 0-22.081 17.964-40.045 40.045-40.045 22.076 0 40.035 17.964 40.035 40.045 0 22.076-17.959 40.035-40.035 40.035zm0-75.91c-19.782 0-35.875 16.093-35.875 35.875 0 19.776 16.093 35.865 35.875 35.865 19.776 0 35.865-16.089 35.865-35.865 0-19.782-16.088-35.875-35.865-35.875zM1474.689 2278.87c24.59 115.41 40.75 117.48 99.17 223.24h298.99L1751.7 2268.36c-70.77-145.56-302.8-132.69-277.011 10.51z"
        class="color949899 svgShape"
      ></path>
      <path
        fill="#949899"
        d="M1229.561 2281.86s-4.87 93.96-4.32 220.25h288.84l1.561-109.63-19.011-117.53c-28.091-122.38-260.551-115.389-267.07 6.91z"
        class="color949899 svgShape"
      ></path>
      <path
        fill="#fccac3"
        d="M2170.51 1339.56c-.92 3.99 17.87 69.061-42.25 93.381l-39.84 134.56-90.811-64.04 57.061-126.26s-15.05-74.521-12.561-89.74c2.48-15.21 22.19-30.57 22.19-30.57s9.271-63.67 28.19-82.84c18.909-19.16 105.199-30.04 115.869-26.71 10.66 3.33 12.341 18.63-10.529 24.46-22.87 5.84-74.41 20.94-74.41 20.94l-12.22 58.45s36.21-35.341 49.54-39.301c13.33-3.949 73.5.59 81.68 11.66 8.189 11.07.29 25.67-15.32 22.84-15.62-2.83-55.51-6.99-55.51-6.99l-30.83 43.44s30.57-25.91 37.77-29.4c7.211-3.489 54.541 15.9 59.9 23.23 5.35 7.34-1.92 22.21-11.24 20.89-9.31-1.31-42.33-16.3-42.33-16.3l-23.33 31.56s34.44-4.67 36.95-5.449c2.521-.78 36.87 25.529 41.67 35.92 4.81 10.4-12.08 20.72-22.95 10-10.88-10.72-20.54-19.11-20.54-19.11l-26.149 5.379z"
        class="colorFCCAC3 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M2110.749 1378.715a2.085 2.085 0 0 1-1.905-2.932c.613-1.387 14.616-34.277-21.478-61.069a2.086 2.086 0 0 1-.83-1.454l-2.33-21.87a2.084 2.084 0 0 1 1.655-2.263c13.837-2.832 36.966-8.756 40.127-12.601 1.668-2.037 3.599-8.231.488-13.307-3.586-5.853-16.371-14.194-61.733-4.292a2.085 2.085 0 1 1-.888-4.074c45.477-9.928 61.09-2.115 66.178 6.188 4.096 6.686 1.932 14.771-.82 18.131-4.641 5.643-31.643 11.748-40.659 13.654l2.034 19.091c37.909 28.75 22.229 65.196 22.066 65.563a2.085 2.085 0 0 1-1.905 1.235z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M1716.391 1785.65c.079-1.141.149-2.301.239-3.431 0 0 164.99 80.12 203.13 96.33 30.4 12.92 68.66 5.24 102.25-45.689 13.62-46.49 17.6-137.021-99.39-207.98l-232.67-129.68s-44.8-34.75-104.16-33.71c-64.59 47.54-98.011 167.35 128.59 321.229l2.011 2.931z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M2022.01 1832.86c8.57-12.99 16.83-28.78 24.58-47.771 38.15-93.45 100.13-349.97 100.13-349.97l-102.04-71.521-122.06 261.28s-35.07 50.521-39.761 128.33c-4.679 77.813 76.741 151.813 139.151 79.652z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1896.39 1680.386a2.083 2.083 0 0 1-1.885-2.974l148.289-314.7a2.084 2.084 0 1 1 3.771 1.777l-148.289 314.7a2.084 2.084 0 0 1-1.886 1.197z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="M1141.59 1588.16c-76.39 30.09-127.49 246.72-174.729 325.93-60.71 150.58 53.569 254.2 112.75 213.341 18.12-21.931 98.22-196.45 98.22-196.45l33.62-120.601c50.929-177.449-69.861-222.22-69.861-222.22z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1115.178 2064.725a2.084 2.084 0 0 1-1.781-3.166c68.658-113.228 95.741-250.205 96.006-251.575a2.084 2.084 0 1 1 4.093.793c-.267 1.378-27.48 139.063-96.535 252.944a2.082 2.082 0 0 1-1.783 1.004z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="m1373.79 1498.99-70.82 9.29s-129.909 67.49-161.38 79.88c-20.87 45.52 6 165.88 36.24 342.819 0 0 42.92 324.23 44.83 423.41 0 0 366.18 26.7 541.65-66.75 0 0-62.2-305.399-47.92-501.99l-2.011-2.93c2.761-313.84-121.42-321.08-128.271-321.24-6.699.11-13.579.66-20.609 1.771-69.141 10.97-121.4 28.819-121.4 28.819l-70.309 6.921z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1218.878 2293.186a2.085 2.085 0 0 1-2.079-1.947c-.126-1.918-12.998-193.666-41.025-359.911a2.084 2.084 0 0 1 1.709-2.402 2.08 2.08 0 0 1 2.403 1.709c28.063 166.458 40.947 358.41 41.074 360.329a2.084 2.084 0 0 1-2.082 2.222zM1743.058 2167.915a2.084 2.084 0 0 1-2.057-1.761c-.301-1.912-30.03-192.2-28.406-284.73 1.621-92.282-3.495-196.25-3.547-197.29a2.085 2.085 0 0 1 1.979-2.186c1.141-.066 2.128.828 2.186 1.979.053 1.04 5.176 105.148 3.553 197.569-1.618 92.169 28.056 282.103 28.355 284.01a2.086 2.086 0 0 1-2.063 2.409zM1402.13 1583.713c-15.257 0-33.567-7.015-54.74-21.01-24.167-15.975-43.366-35.675-43.557-35.872a2.085 2.085 0 0 1 2.994-2.902c.746.769 75.088 76.638 115.601 49.783a2.087 2.087 0 0 1 2.304 3.477c-6.566 4.351-14.111 6.524-22.602 6.524z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M1452.179 1546.065a2.085 2.085 0 0 1-1.904-2.933c9.183-20.656 4.608-54.485 4.561-54.824a2.086 2.086 0 0 1 4.13-.577c.2 1.433 4.791 35.34-4.88 57.094a2.086 2.086 0 0 1-1.907 1.24z"
        class="colorFFF svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1511.782 2238.866c-.162 0-.327-.02-.491-.06-84.396-20.385-219.811-138.966-221.168-140.161a2.086 2.086 0 0 1 2.754-3.131c1.351 1.189 135.997 119.095 219.392 139.239a2.084 2.084 0 0 1 1.537 2.516 2.084 2.084 0 0 1-2.024 1.597zM1530.463 2275.279c-43.946 0-83.956-11.575-111.697-22.365-36.273-14.106-60.015-29.977-60.25-30.135a2.085 2.085 0 0 1 2.329-3.459c.232.156 23.666 15.81 59.536 29.748 33.036 12.836 83.688 26.807 137.406 20.462a2.09 2.09 0 0 1 2.314 1.826 2.083 2.083 0 0 1-1.826 2.314c-9.389 1.11-18.687 1.609-27.812 1.609zM1676.28 2168.785a2.085 2.085 0 0 1-1.53-3.502c.452-.488 45.251-49.781 49.007-129.212.055-1.15 1.051-1.997 2.182-1.984a2.086 2.086 0 0 1 1.984 2.182c-3.832 81.014-49.65 131.35-50.113 131.849a2.081 2.081 0 0 1-1.53.667z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#fccac3"
        d="M666.061 1794.7c2.39 3.34 9.64 69.979 74.489 69.5l117.89 148.68 77.421-96.51-148.57-131.78s-14.33-73.95-22.44-87.06c-8.109-13.11-32.189-19.791-32.189-19.791s-32.88-55.3-57.67-65.789c-24.801-10.5-108.71 12.39-117.301 19.55-8.579 7.149-4.289 21.93 19.07 18.59 23.37-3.34 76.771-9.061 76.771-9.061l33.609 49.351s-46.96-18.83-60.79-17.4-67.71 28.61-71.039 41.96c-3.341 13.351 9.529 23.84 22.88 15.26 13.35-8.579 48.64-27.649 48.64-27.649l45.07 28.38s-38.141-12.28-46.131-12.75c-7.989-.48-44.34 35.52-46.479 44.33-2.149 8.819 10.24 19.79 18.351 15.02 8.109-4.76 32.899-31.229 32.899-31.229l33.62 20.27s-33.62 8.83-36.24 9.061c-2.62.24-24.32 37.67-24.8 49.109-.47 11.45 19.08 14.54 25.04.48 5.96-14.061 11.68-25.51 11.68-25.51l26.219-5.012z"
        class="colorFCCAC3 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M735.45 1808.235a2.076 2.076 0 0 1-1.435-.572c-.292-.277-28.691-27.976-4.641-69.017l-5.404-18.427c-9.063 1.681-36.353 6.349-42.795 2.898-3.823-2.047-8.91-8.685-7.681-16.43 1.526-9.621 12.966-22.809 58.799-31.001a2.085 2.085 0 0 1 .733 4.106c-45.709 8.169-54.338 20.767-55.415 27.549-.933 5.881 3.212 10.858 5.532 12.101 4.394 2.353 28.032-1.001 41.901-3.67a2.084 2.084 0 0 1 2.395 1.461l6.19 21.109c.164.559.087 1.16-.212 1.659-23.181 38.64 3.198 64.381 3.468 64.636a2.085 2.085 0 0 1-1.435 3.598z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#E3405F"
        d="m964.48 1910.45-.25.51-171.65-154.49s-41.96 36.24-67.71 114.44c0 0 171.649 238.399 207.89 267.01 36.23 28.61 128.73 11.44 146.851-10.49 20.819-36.64-6.75-83.819-6.75-83.819-40.311-75-106-129.521-106-129.521l-2.381-3.64z"
        class="colorE3405F svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1001.9 1947.865c-.499 0-.999-.178-1.398-.539l-209.32-189.31a2.086 2.086 0 0 1 2.797-3.092l209.32 189.31a2.086 2.086 0 0 1-1.399 3.631z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#fccac3"
        d="M1280.08 1349.979s43.87 117.291 22.89 158.301c0 0 69.61 66.75 105.851 57.22 36.24-9.54 35.279-73.43 35.279-73.43s-16.439-5.721-20.729-20.74c-4.29-15.021-17.64-90.11-17.64-90.11s-18.601-76.29-125.651-31.241z"
        class="colorFCCAC3 svgShape"
      ></path>
      <path
        fill="#ed6056"
        d="M1280.08 1349.979s5.15 13.761 11.08 33.521v.01a632.74 632.74 0 0 1 3.42 11.8c9.26 26.4 40.29 86.69 127.41 70.53-5.23-22.569-16.26-84.62-16.26-84.62s-18.6-76.29-125.65-31.241z"
        class="colorED6056 svgShape"
      ></path>
      <path
        fill="#fccac3"
        d="M1229.24 1256.479s33.38 164.021 116.34 178.32c82.97 14.311 205.029-13.34 109.67-312.779 0 .001-226.96-66.74-226.01 134.459z"
        class="colorFCCAC3 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1238.78 1327.06s-46.73-30.51-83.92-123.97c-37.19-93.46 20.979-92.5 20.979-92.5s-45.78-97.27 120.15-116.34c165.93-19.07 208.85-35.28 200.26 21.93 0 0 42.92 12.4 39.1 64.851-3.81 52.45-172.359 86.37-282.29 83.2.001-.001 30.541 149.489-14.279 162.829z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#fccac3"
        d="M1268.33 1261.75s-32.9-31.95-65.79-9.54c-32.9 22.41-13.83 125.87 72.47 83.439l-6.68-73.899z"
        class="colorFCCAC3 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="m1231.4 1158.29 21.66 5.939s26.01 136.141 49.859 165.221c23.84 29.09 186.96-35.78 186.96-35.78s13.78 79.66 5.681 106.84c-8.11 27.181-122.07 83.92-189.771 20.98-67.709-62.94-74.389-263.2-74.389-263.2z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1403.964 1297.997c-2.712 0-5.61-.253-8.703-.826a2.085 2.085 0 0 1 .76-4.1c20.104 3.724 30.991-7.301 34.102-11.145-12.535-14.254-30.391-58.938-31.169-60.895a2.086 2.086 0 0 1 3.875-1.541c.194.487 19.521 48.861 31.476 60.806.689.689.81 1.764.29 2.588-.11.171-9.817 15.111-30.631 15.113zM1309.34 1216.93s48.391-11.439 62.939-14.069c14.541-2.62.24-12.87-15.26-13.351-15.499-.48-54.119 22.41-47.679 27.42zM1471.47 1187.96s-42.939 4.66-55.61 6.83c-12.68 2.18-3.779-12.12 8.82-17.53 12.599-5.42 50.69 3.889 46.79 10.7z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="m1371.88 1351.7 89.54-21.09c4.36 25.93-46.13 65.34-89.54 21.09z"
        class="colorFFF svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1356.118 1254.045a2.084 2.084 0 0 1-1.804-3.128c4.074-7.054-5.003-14.902-5.096-14.98a2.085 2.085 0 0 1 2.703-3.175c.484.413 11.795 10.212 6.004 20.241a2.082 2.082 0 0 1-1.807 1.042zM1442.141 1237.355a2.085 2.085 0 0 1-1.969-2.77c3.577-10.283-3.236-12.952-3.528-13.06a2.085 2.085 0 0 1 1.454-3.908c.11.041 10.916 4.245 6.013 18.338-.3.86-1.108 1.4-1.97 1.4zM1251.08 1317.96s-20.59-47.61-39.43-47.37c-18.83.24 12.16 52.931 39.43 47.37zM1134.431 1122.474a2.084 2.084 0 0 1-1.436-3.597c.241-.228 24.307-22.59 49.679-7.911a2.086 2.086 0 0 1-2.088 3.61c-22.655-13.106-43.833 6.489-44.724 7.329a2.08 2.08 0 0 1-1.431.569z"
        class="color2A1D19 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M1391.658 1137.495a2.084 2.084 0 0 1-.221-4.158c86.226-9.326 119.907-46.607 120.237-46.983a2.084 2.084 0 0 1 3.136 2.748c-1.385 1.582-34.918 38.862-122.925 48.38a1.957 1.957 0 0 1-.227.013z"
        class="colorFFF svgShape"
      ></path>
      <path
        fill="#353640"
        d="M2743.43 2504.186H256.57a2.086 2.086 0 0 1 0-4.17h2486.86a2.086 2.086 0 0 1 0 4.17z"
        class="color353640 svgShape"
      ></path>
      <path
        fill="#d0d3d4"
        d="m1940.08 1728.97 565.64-102.241-.72 28.451-565.63 102.24z"
        class="colorD0D3D4 svgShape"
      ></path>
      <path
        fill="#d0d3d4"
        d="m2235.83 1292.34 507.6-91.75-127.79 434.59-507.61 91.75z"
        class="colorD0D3D4 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="m2379.9 1441.49 110.64-20-18.99 64.55-110.63 20z"
        class="colorFFF svgShape"
      ></path>
      <path
        fill="#2a1d19"
        d="M1940.078 1731.055a2.086 2.086 0 0 1-.369-4.137l175.475-31.721 118.646-403.446a2.084 2.084 0 0 1 1.629-1.463l353.42-63.88a2.086 2.086 0 0 1 .742 4.104l-352.154 63.651-118.646 403.446a2.087 2.087 0 0 1-1.629 1.464l-176.74 31.949a2.183 2.183 0 0 1-.374.033zm349.99-34.94a2.086 2.086 0 0 1-.369-4.137l324.304-58.622 74.357-252.875a2.085 2.085 0 0 1 4 1.177l-74.72 254.109a2.087 2.087 0 0 1-1.629 1.464l-325.57 58.851c-.126.022-.25.033-.373.033z"
        class="color2A1D19 svgShape"
      ></path>
    </svg>
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   enable-background="new 0 0 500 500"
    //   viewBox="0 0 500 500"
    //   width="550"
    //   height="550"
    // >
    //   <rect
    //     width="89.43"
    //     height=".66"
    //     x="231.89"
    //     y="463.81"
    //     fill="#505ea3"
    //     class="color505ea3 svgShape"
    //   ></rect>
    //   <rect
    //     width="142.74"
    //     height=".66"
    //     x="85.18"
    //     y="463.81"
    //     fill="#505ea3"
    //     class="color505ea3 svgShape"
    //   ></rect>
    //   <path
    //     fill="#d2e1f7"
    //     d="M49.66,302.71c1.11,30.83,24.61,60.76,55.68,65.45c26.43,3.98,53.01-0.48,79.42-2.23			c26.18-1.73,54.72-1.78,80.09,5.84c37.41,11.24,71.03,36.86,111.19,37.91c36.1,0.94,66.48-26.48,76.79-59.83
    // 	c6.35-20.52,4.33-42-6.75-60.5c-10.89-18.17-28.83-29.73-44.59-43.17c-15.33-13.07-24.91-31.11-31.7-49.84
    // 	c-13.68-37.73-17.5-81.2-44.3-112.89c-46.9-55.47-140.08-51.87-190.81-3.25c-12.53,12.01-22.57,27.66-28.53,44.36
    // 	c-10.49,29.39-5.9,60.54-18.27,89.97C75.88,243.08,48.49,270.13,49.66,302.71z"
    //     class="colord2e1f7 svgShape"
    //   ></path>
    //   <circle
    //     cx="187.11"
    //     cy="67.27"
    //     r="3.39"
    //     fill="#ffffff"
    //     class="colorfff svgShape"
    //   ></circle>
    //   <circle
    //     cx="395.49"
    //     cy="196.88"
    //     r="3.39"
    //     fill="#d64e12"
    //     class="colord64e12 svgShape"
    //   ></circle>
    //   <circle
    //     cx="351.96"
    //     cy="311.28"
    //     r="3.39"
    //     fill="#505ea3"
    //     class="color505ea3 svgShape"
    //   ></circle>
    //   <circle
    //     cx="415.56"
    //     cy="343.39"
    //     r="3.39"
    //     fill="#ffffff"
    //     class="colorfff svgShape"
    //   ></circle>
    //   <circle
    //     cx="63.02"
    //     cy="198.22"
    //     r="3.39"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></circle>
    //   <path
    //     fill="#505ea3"
    //     d="M309.89,104.36v235.89c0,3.76-3.05,6.81-6.81,6.81H162.47c-3.77,0-6.82-3.05-6.82-6.82V104.36
    // 		c0-3.75,3.06-6.81,6.82-6.81h44.47c1.61,0,2.92,1.31,2.92,2.92v0c0,1.61,1.31,2.92,2.92,2.92h39.96c1.61,0,2.92-1.31,2.92-2.92v0
    // 		c0-1.61,1.31-2.92,2.92-2.92h44.47C306.83,97.55,309.89,100.61,309.89,104.36z"
    //     class="color505ea3 svgShape"
    //   ></path>
    //   <rect
    //     width="126.94"
    //     height="70.74"
    //     x="169.3"
    //     y="174.14"
    //     fill="#505ea3"
    //     opacity=".5"
    //     class="color505ea3 svgShape"
    //   ></rect>
    //   <rect
    //     width="126.94"
    //     height="70.74"
    //     x="169.3"
    //     y="261.44"
    //     fill="#505ea3"
    //     opacity=".5"
    //     class="color505ea3 svgShape"
    //   ></rect>
    //   <path
    //     fill="#ffffff"
    //     d="M322.02,348.75H205.39c-2.77,0-5.01-2.24-5.01-5.01v-64.27c0-2.77,2.24-5.01,5.01-5.01h116.64
    // 		c2.77,0,5.01,2.24,5.01,5.01v64.27C327.03,346.51,324.79,348.75,322.02,348.75z"
    //     class="colorfff svgShape"
    //   ></path>
    //   <rect
    //     width="17.89"
    //     height="17.89"
    //     x="209.85"
    //     y="289.12"
    //     fill="#d64e12"
    //     class="colord64e12 svgShape"
    //   ></rect>
    //   <rect
    //     width="84.96"
    //     height="3.93"
    //     x="232.6"
    //     y="290.2"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <rect
    //     width="84.96"
    //     height="3.93"
    //     x="232.6"
    //     y="302"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <rect
    //     width="17.89"
    //     height="17.89"
    //     x="209.85"
    //     y="316.21"
    //     fill="#d64e12"
    //     class="colord64e12 svgShape"
    //   ></rect>
    //   <rect
    //     width="84.96"
    //     height="3.93"
    //     x="232.6"
    //     y="317.3"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <rect
    //     width="84.96"
    //     height="3.93"
    //     x="232.6"
    //     y="329.09"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <path
    //     fill="#d64e12"
    //     d="M230.73,168.34l-61.91,0c-1.08,0-1.95-0.87-1.95-1.95V128.5c0-1.08,0.87-1.95,1.95-1.95l61.91,0
    // 				c1.08,0,1.95,0.87,1.95,1.95v37.89C232.68,167.46,231.81,168.34,230.73,168.34z"
    //     class="colord64e12 svgShape"
    //   ></path>
    //   <path
    //     fill="#ffffff"
    //     d="M171.48,155.84l5.06-5.06c3.18-3.18,8.34-3.18,11.52,0l3.69,3.69c0.2,0.2,0.52,0.2,0.72,0l13.42-13.42
    // 				c2.19-2.19,5.75-2.19,7.94,0l14.24,14.24c0.1,0.1,0.15,0.23,0.15,0.36v8.54c0,0.28-0.23,0.51-0.51,0.51l-55.87,0
    // 				c-0.28,0-0.51-0.23-0.51-0.51l0-7.99C171.33,156.07,171.38,155.94,171.48,155.84z"
    //     class="colorfff svgShape"
    //   ></path>
    //   <circle
    //     cx="182.13"
    //     cy="142.43"
    //     r="3.37"
    //     fill="#ffffff"
    //     class="colorfff svgShape"
    //   ></circle>
    //   <rect
    //     width="53.43"
    //     height="3.76"
    //     x="241.72"
    //     y="127.62"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <rect
    //     width="53.43"
    //     height="3.76"
    //     x="241.72"
    //     y="139.58"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <rect
    //     width="53.43"
    //     height="3.76"
    //     x="241.72"
    //     y="151.54"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <rect
    //     width="53.43"
    //     height="3.76"
    //     x="241.72"
    //     y="163.49"
    //     fill="#9fbff4"
    //     class="color9fbff4 svgShape"
    //   ></rect>
    //   <g fill="#000000" class="color000 svgShape">
    //     <path
    //       fill="#212e57"
    //       d="M241.46,235.02h92.5c1.19,0,2.16-0.97,2.16-2.16V182.9c0-1.19-0.97-2.16-2.16-2.16h-92.5
    // 			c-1.19,0-2.16,0.97-2.16,2.16v49.96C239.3,234.05,240.27,235.02,241.46,235.02z"
    //       class="color212e57 svgShape"
    //     ></path>
    //     <rect
    //       width="23.31"
    //       height="1.65"
    //       x="252.03"
    //       y="187.03"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="7.19"
    //       height="1.65"
    //       x="278.08"
    //       y="187.03"
    //       fill="#d64e12"
    //       opacity=".5"
    //       class="colord64e12 svgShape"
    //     ></rect>
    //     <rect
    //       width="1.97"
    //       height="1.65"
    //       x="246.62"
    //       y="187.03"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="9.86"
    //       height="1.65"
    //       x="307.49"
    //       y="187.03"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="16.64"
    //       height="1.65"
    //       x="288.72"
    //       y="187.03"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <polygon
    //       fill="#505ea3"
    //       points="279.5 218.14 278.08 218.14 252.03 218.14 252.03 219.78 278.08 219.78 279.5 219.78 285.27 219.78 285.27 218.14"
    //       class="color505ea3 svgShape"
    //     ></polygon>
    //     <rect
    //       width="1.97"
    //       height="1.65"
    //       x="246.62"
    //       y="218.14"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="5.43"
    //       height="1.65"
    //       x="307.49"
    //       y="218.14"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="16.64"
    //       height="1.65"
    //       x="288.72"
    //       y="218.14"
    //       fill="#d64e12"
    //       opacity=".5"
    //       class="colord64e12 svgShape"
    //     ></rect>
    //     <rect
    //       width="4.77"
    //       height="1.65"
    //       x="252.03"
    //       y="192.21"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="26.86"
    //       height="1.65"
    //       x="258.88"
    //       y="192.21"
    //       fill="#9fbff4"
    //       opacity=".5"
    //       class="color9fbff4 svgShape"
    //     ></rect>
    //     <rect
    //       width="1.97"
    //       height="1.65"
    //       x="246.62"
    //       y="192.21"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="40.01"
    //       height="1.65"
    //       x="288.72"
    //       y="192.21"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="4.77"
    //       height="1.65"
    //       x="252.03"
    //       y="223.32"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="4.77"
    //       height="1.65"
    //       x="290.62"
    //       y="223.32"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="26.86"
    //       height="1.65"
    //       x="258.88"
    //       y="223.32"
    //       fill="#9fbff4"
    //       opacity=".5"
    //       class="color9fbff4 svgShape"
    //     ></rect>
    //     <rect
    //       width="1.97"
    //       height="1.65"
    //       x="246.62"
    //       y="223.32"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <rect
    //       width="29.16"
    //       height="1.65"
    //       x="299.57"
    //       y="223.32"
    //       fill="#505ea3"
    //       class="color505ea3 svgShape"
    //     ></rect>
    //     <g fill="#000000" class="color000 svgShape">
    //       <rect
    //         width="14.5"
    //         height="1.65"
    //         x="252.03"
    //         y="197.4"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="7.06"
    //         height="1.65"
    //         x="268.28"
    //         y="197.4"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="1.97"
    //         height="1.65"
    //         x="246.62"
    //         y="197.4"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="21.86"
    //         height="1.65"
    //         x="278.57"
    //         y="197.4"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="25.93"
    //         height="1.65"
    //         x="302.8"
    //         y="197.4"
    //         fill="#d64e12"
    //         opacity=".5"
    //         class="colord64e12 svgShape"
    //       ></rect>
    //     </g>
    //     <g fill="#000000" class="color000 svgShape">
    //       <rect
    //         width="38.42"
    //         height="1.65"
    //         x="252.03"
    //         y="202.58"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="1.97"
    //         height="1.65"
    //         x="246.62"
    //         y="202.58"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="28.37"
    //         height="1.65"
    //         x="292.47"
    //         y="202.58"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //     </g>
    //     <g fill="#000000" class="color000 svgShape">
    //       <rect
    //         width="19.72"
    //         height="1.65"
    //         x="252.03"
    //         y="207.77"
    //         fill="#d64e12"
    //         opacity=".5"
    //         class="colord64e12 svgShape"
    //       ></rect>
    //       <rect
    //         width="1.97"
    //         height="1.65"
    //         x="246.62"
    //         y="207.77"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="37.6"
    //         height="1.65"
    //         x="283.23"
    //         y="207.77"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="5.07"
    //         height="1.65"
    //         x="323.66"
    //         y="207.77"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="5.07"
    //         height="1.65"
    //         x="274.37"
    //         y="207.77"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //     </g>
    //     <g fill="#000000" class="color000 svgShape">
    //       <rect
    //         width="9.92"
    //         height="1.65"
    //         x="252.03"
    //         y="212.95"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="9.92"
    //         height="1.65"
    //         x="272.03"
    //         y="212.95"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="1.97"
    //         height="1.65"
    //         x="246.62"
    //         y="212.95"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="25.7"
    //         height="1.65"
    //         x="285.64"
    //         y="212.95"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //       <rect
    //         width="14"
    //         height="1.65"
    //         x="314.73"
    //         y="212.95"
    //         fill="#9fbff4"
    //         opacity=".5"
    //         class="color9fbff4 svgShape"
    //       ></rect>
    //       <rect
    //         width="5.07"
    //         height="1.65"
    //         x="264.64"
    //         y="212.95"
    //         fill="#505ea3"
    //         class="color505ea3 svgShape"
    //       ></rect>
    //     </g>
    //   </g>
    //   <g fill="#000000" class="color000 svgShape">
    //     <path
    //       fill="#ffffff"
    //       d="M313,82.55h-72.64c-1.38,0-2.51-1.12-2.51-2.51V56.33c0-1.38,1.12-2.51,2.51-2.51H313
    // 		c1.38,0,2.51,1.12,2.51,2.51v23.71C315.5,81.42,314.38,82.55,313,82.55z"
    //       class="colorfff svgShape"
    //     ></path>
    //     <text
    //       fill="#505ea3"
    //       font-family="Poppins-Bold"
    //       font-size="18.134"
    //       transform="translate(252.041 74.298)"
    //     >
    //       HTML
    //     </text>
    //   </g>
    //   <g fill="#000000" class="color000 svgShape">
    //     <path
    //       fill="#505ea3"
    //       d="M382.55,169.54h-57.53c-1.24,0-2.24-1-2.24-2.24v-24.25c0-1.24,1-2.24,2.24-2.24h57.53
    // 		c1.24,0,2.24,1,2.24,2.24v24.25C384.79,168.54,383.78,169.54,382.55,169.54z"
    //       class="color505ea3 svgShape"
    //     ></path>
    //     <text
    //       fill="#9fbff4"
    //       font-family="Poppins-Bold"
    //       font-size="18.134"
    //       transform="translate(335.724 161.293)"
    //     >
    //       CSS
    //     </text>
    //   </g>
    //   <g fill="#000000" class="color000 svgShape">
    //     <path
    //       fill="#505ea3"
    //       d="M133.2,137.98H89.07c-1.09,0-1.97-0.88-1.97-1.97v-24.78c0-1.09,0.88-1.97,1.97-1.97h44.13
    // 		c1.09,0,1.97,0.88,1.97,1.97v24.78C135.18,137.1,134.29,137.98,133.2,137.98z"
    //       class="color505ea3 svgShape"
    //     ></path>
    //     <text
    //       fill="#9fbff4"
    //       font-family="Poppins-Bold"
    //       font-size="18.134"
    //       transform="translate(100.32 129.73)"
    //     >
    //       JS
    //     </text>
    //   </g>
    //   <g fill="#000000" class="color000 svgShape">
    //     <path
    //       fill="#e8c4b3"
    //       d="M132.91,204.14c-7.95,6.92,11.19,58.03,17.56,54.26C162.46,257.56,147.91,195.6,132.91,204.14z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M153.27,232.8l3.64,19.76l10.79,3.64l-0.65,10.05c0,0-17.38,0-21.77-5.89
    // 				c-4.39-5.89-8.13-23.45-8.13-23.45L153.27,232.8z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#d64e12"
    //       d="M121.69,197.31c27.5-1.28,28.29,20.64,32.53,35.59l-17.73,5.12L121.69,197.31z"
    //       class="colord64e12 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M146.31,258.97c0.08,1.56,1.1,2.93,2.48,3.66c10.81,5.68,36.73,3.98,36.17,0.17
    // 					C184.59,260.31,145.7,247.24,146.31,258.97z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M180.49 260.77l-.49-.39 1.26-.72.01 0 2.23-1.14c.58-.29 1.2-.43 1.84-.42l2.74.74c0 0 .44.75-1.17.74-.42 0-1 .35-1.45.66l1.58.23 3.83.85c.98.21 2.02 1.25 1.82 2.43 0 0-.41 1.62-2.28 1.97l-2.55.71c-1.38.14-2.43.5-3.75.09l-3.52-1.43L180.49 260.77zM129.86 272.48c-15.57.59-7.75 15.04-4.71 27.76 5.53 19.98 2.69 45.97 10.79 48.74 21.59 6.35 13.98-70.1 7.97-73.55C141.09 273.85 135.09 272.97 129.86 272.48z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M144.58,342.24c-15.2-10.72-13.36,78.62-9.14,98.93c4.21,20.31,8.37-10.51,11.06-43.03
    // 						C149.18,365.62,150.56,346.46,144.58,342.24z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <polygon
    //       fill="#e8c4b3"
    //       points="132.9 437.7 133.21 446.64 144.42 446.79 144.42 438.76"
    //       class="colore8c4b3 svgShape"
    //     ></polygon>
    //     <path
    //       fill="#03254e"
    //       d="M145.41,446.9c0,0,2.36,4.57,10.19,10.52c7.82,5.96,9.87,4.67,10.05,6.89
    // 						c0.18,2.22-33.35,0.29-33.35,0.29l0.68-18.24C132.98,446.36,145.41,446.42,145.41,446.9z"
    //       class="color03254e svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M113.23,272.86c-15.28-3.04-15.11,13.43-15.1,26.51c0.73,20.72-4,44.73,3.23,49.31
    // 					c19.52,11.2,25.06-67.4,20.02-72.15C119,274.34,118.21,274.55,113.23,272.86z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M109.45,342.24c-7.81-5.5-14.44,73.41-9.14,98.93c4.21,20.31,8.37-10.51,11.06-43.03
    // 						C114.05,365.62,115.43,346.46,109.45,342.24z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <polygon
    //       fill="#e8c4b3"
    //       points="98.42 441.44 98.38 448.89 110.31 448.98 110.29 442.41"
    //       class="colore8c4b3 svgShape"
    //     ></polygon>
    //     <path
    //       fill="#03254e"
    //       d="M98.27,448.79c-0.15,2.94-3.22,13-3.29,15.55c18.97,0.48,18.43,4.3,15.37-15.49L98.27,448.79z"
    //       class="color03254e svgShape"
    //     ></path>
    //     <path
    //       fill="#212e57"
    //       d="M154,350.78c-0.27,9.31-9.22,88.92-9.22,88.92l-12.17-0.53c0,0-4.94-44.87-1.1-87.94l-7.13-39.96
    // 		l-13.63,131.16h-12.9c0,0-0.46-80.3-1.28-92.93c-0.82-12.62,2.11-72.71,2.11-72.71l50.2,1.83
    // 		C148.88,278.6,154.29,341.45,154,350.78z"
    //       class="color212e57 svgShape"
    //     ></path>
    //     <path
    //       fill="#d64e12"
    //       d="M148.88,278.59c0.17,3.07-24.77,2.98-39.53,1.22c-6.23-0.75-10.65-1.8-10.65-3.04
    // 		c1.53-22.79-1.04-39.62-2.79-51.9c-2.75-19.28-3.52-27.39,16.63-29.96l15.35,1.55C159.29,202.1,143.39,232.4,148.88,278.59z"
    //       class="colord64e12 svgShape"
    //     ></path>
    //     <rect
    //       width="48.14"
    //       height="2.35"
    //       x="134.85"
    //       y="260.37"
    //       fill="#1b3689"
    //       transform="matrix(1 .00986 -.00986 1 2.587 -1.554)"
    //       class="color1b3689 svgShape"
    //     ></rect>
    //     <polygon
    //       fill="#1b3689"
    //       points="195.56 263.08 150.77 262.64 163.7 232.23 208.5 232.67"
    //       class="color1b3689 svgShape"
    //     ></polygon>
    //     <polygon
    //       fill="#d2e1f7"
    //       points="196.82 263.09 152.03 262.65 164.97 232.24 209.76 232.68"
    //       class="colord2e1f7 svgShape"
    //     ></polygon>
    //     <ellipse
    //       cx="182.06"
    //       cy="248.22"
    //       fill="#ffffff"
    //       rx="3.94"
    //       ry="2.61"
    //       transform="rotate(-67.574 182.042 248.211)"
    //       class="colorfff svgShape"
    //     ></ellipse>
    //     <path
    //       fill="#d64e12"
    //       d="M109.34,279.81c-6.23-0.75-10.65-1.8-10.65-3.04c1.53-22.79-1.04-39.62-2.79-51.9l7.89-0.83
    // 		c0,0-3.07,17.93-2.53,32.25C101.77,269.78,102.4,277.39,109.34,279.81z"
    //       class="colord64e12 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M127.95,192.18v0.16l-0.02,2.37l-0.08,6.18c0,0.02,0,0.04-0.02,0.06c-0.74,7.93-13.23-0.68-14.63-3.98
    // 		c-0.97-2.12,0.47-3.19,0.51-7.66c0.04-4.45,0.04-4.96,0.04-4.96c-14.98-23.83,10.03-33.52,19.59-16.62
    // 		c0,5.54,0.58,10.92,0.68,15.26C134.21,189.48,133.34,193.58,127.95,192.18z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#03254e"
    //       d="M136.76,162.82c0.11,2.49-0.81,4.9-3.16,6.27c-2.23,1.3-4.81,1.07-7.12,0.13c-2.36-0.96-4.85-2.35-7.39-1.09
    // 		c-3.52,1.74-0.8,7.28-0.8,10.07v0.07c-0.62,0.28-1.38,0.61-1.99,0.83c-0.32-2.03-0.97-3.92-2.29-3.88
    // 		c-1.89,0.08,0.08,9.05-0.26,9.14c-0.21,0.05-2.39-3.14-3.82-7.16c-0.29-0.8-0.54-1.64-0.75-2.49c-1.34-5.55-0.9-14.24,5.78-16.09
    // 		c2.8-0.77,5.64-1.43,8.28-2.66c2.6-1.21,5.24-2.62,8.14-1.45C134.47,155.76,136.61,159.37,136.76,162.82z"
    //       class="color03254e svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M98.91,202.47c-8.39,5.91,4.81,59.95,11.35,56.93C121.96,259.77,114.28,195.69,98.91,202.47z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M115.85,236.44l1.96,11.63l18.64-4.06l2.87,9.11c0,0-25.72,12.47-31.12,7.22s-8.97-21.87-8.97-21.87
    // 			L115.85,236.44z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#d64e12"
    //       d="M111.24,207.75l5.6,28.98l-18.61,3.16c0,0-5.07-26.49-4.44-33.11c0.13-1.29,0.77-2.68,1.68-4.06
    // 			c0.04-0.06,0.08-0.12,0.12-0.17C99.96,196.17,109.49,200.23,111.24,207.75z"
    //       class="colord64e12 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M108,259.1c0.7,1.35,2.15,2.15,3.66,2.24c11.85,0.69,52.87-19.03,50.29-21.32
    // 					C160.92,237.8,102.75,248.96,108,259.1z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M154.87,240.49l-0.6-0.15l0.82-1.14l0.01-0.01l1.52-1.9c0.39-0.49,0.89-0.87,1.46-1.11l2.72-0.44
    // 					c0,0,0.69,0.49-0.74,1.12c-0.37,0.17-0.74,0.71-1.02,1.16l1.49-0.43l3.37-0.89c0.95-0.21,2.02,4.16,0.52,5.22l-0.77,0.61
    // 					c-1.17,0.68-1.95,1.42-3.29,1.59l-3.69,0.15L154.87,240.49z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //     <path
    //       fill="#d7cfbb"
    //       d="M127.95,192.18l-0.02,2.53c-1.87-1.83-5.09-5.01-5.09-5.01C125,191.33,127.95,192.18,127.95,192.18z"
    //       class="colord7cfbb svgShape"
    //     ></path>
    //     <path
    //       fill="#03254e"
    //       d="M127.95,192.18v0.16c-2.12-0.82-4.08-1.73-5.11-2.64c-2.95-2.62-6.53-10.59-6.53-10.59l1.98-0.84
    // 		c0,0,2.1,5.77,6.02,5.69c3.75-0.1,7.5-2.22,9.7-0.97C134.21,189.48,133.34,193.58,127.95,192.18z"
    //       class="color03254e svgShape"
    //     ></path>
    //     <path
    //       fill="#e8c4b3"
    //       d="M128.26,186.84c0.03-0.08,1.71-1.28,3.68-1.14c0.57,0.04,1.46,0.85,1.71,1.42
    // 		C133.66,187.11,130.32,189.19,128.26,186.84z"
    //       class="colore8c4b3 svgShape"
    //     ></path>
    //   </g>
    //   <polygon
    //     fill="#505ea3"
    //     points="131.51 351.22 124.38 311.26 126.03 296.56"
    //     opacity=".5"
    //     class="color505ea3 svgShape"
    //   ></polygon>
    // </svg>
    // <svg
    //   id="1dff4cb4-53bd-4ffc-acc1-5e8a2ceb72de"
    //   data-name="Layer 1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   // xmlns:xlink="http://www.w3.org/1999/xlink"
    //   width="100%"
    //   height="100%"
    //   viewBox="0 0 864.81 658.45"
    // >
    //   <defs>
    //     <linearGradient
    //       id="e6219774-622b-406f-ae45-f26a74b1f5cd"
    //       x1="477.09"
    //       y1="779.22"
    //       x2="477.09"
    //       y2="120.78"
    //       gradientUnits="userSpaceOnUse"
    //     >
    //       <stop offset="0" stopColor="gray" stopOpacity="0.25" />
    //       <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
    //       <stop offset="1" stopColor="gray" stopOpacity="0.1" />
    //     </linearGradient>
    //     <linearGradient
    //       id="2394db48-9094-48a1-80b4-38413320a0c3"
    //       x1="309.42"
    //       y1="623"
    //       x2="309.42"
    //       y2="461"
    //       // xlink:href="#e6219774-622b-406f-ae45-f26a74b1f5cd"
    //     />
    //     <linearGradient
    //       id="894cb520-7283-4f65-92a7-edb841614828"
    //       x1="773.42"
    //       y1="549"
    //       x2="773.42"
    //       y2="387"
    //       // xlink:href="#e6219774-622b-406f-ae45-f26a74b1f5cd"
    //     />
    //     <linearGradient
    //       id="43bfcda2-dcfb-4411-a28b-16db327cb63c"
    //       x1="664.42"
    //       y1="277"
    //       x2="664.42"
    //       y2="115"
    //       // xlink:href="#e6219774-622b-406f-ae45-f26a74b1f5cd"
    //     />
    //   </defs>
    //   <title></title>

    //   <g opacity="0.7">
    //     <path
    //       d="M506.4,473.94l-.59-.14V451.2a120.23,120.23,0,0,0,89.79-97.09l.29,0c5.77,0,10.44-8.77,10.44-19.58,0-6.71-1.8-12.62-4.54-16.15q.62-6.2.63-12.57a125,125,0,0,0-38.62-90.49,80.54,80.54,0,0,0-8.87-23.81c-8.9-15.68-23.71-32-17.67-49l-39.1,4-.36-25.76c-12.2,2.19-17.31,16.33-24.55,26.4-17.41,24.22-52.35,27.59-75.46,46.45-7.85,6.41-25.51,25.9-22.19,38.68a124.75,124.75,0,0,0-23.84,73.53q0,6.36.63,12.57c-2.74,3.53-4.54,9.44-4.54,16.15,0,10.82,4.68,19.58,10.44,19.58l.29,0a120.23,120.23,0,0,0,89.79,97.09v22.6l-.59.14C434.32,472.37,298.48,462,328.27,685.4l18.27,67.36,4.07-.16A28.72,28.72,0,0,0,407,757.71c25.87-.09,55.09-.17,70-.17s44.18.09,70,.17a28.72,28.72,0,0,0,56.44-5.11l4.07.16,18.27-67.36C655.71,462,519.86,472.37,506.4,473.94Z"
    //       transform="translate(-167.6 -120.78)"
    //       fill="url(#e6219774-622b-406f-ae45-f26a74b1f5cd)"
    //     />
    //   </g>
    //   <rect y="625.16" width="645.61" height="21.88" fill={theme.imageDark} />
    //   <rect
    //     x="27.36"
    //     y="647.05"
    //     width="590.89"
    //     height="8.95"
    //     fill={theme.imageDark}
    //   />
    //   <rect x="27.36" y="647.05" width="590.89" height="2.98" opacity="0.1" />
    //   <path
    //     d="M361,747.61s86.63-.34,116.09-.34,116.09.34,116.09.34V735H361Z"
    //     transform="translate(-167.6 -120.78)"
    //     opacity="0.1"
    //   />
    //   <path
    //     d="M593.19,745.08s-86.63-.34-116.09-.34-116.09.34-116.09.34V585.74A116.09,116.09,0,0,1,477.09,469.65h0A116.09,116.09,0,0,1,593.19,585.74Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill={theme.accentColor}
    //   />
    //   <path
    //     d="M298.5,290.83h22a16.76,16.76,0,0,1,16.76,16.76v46.33a27.76,27.76,0,0,1-27.76,27.76h0a27.76,27.76,0,0,1-27.76-27.76V307.59A16.76,16.76,0,0,1,298.5,290.83Z"
    //     fill={theme.skinColor}
    //   />
    //   <path
    //     d="M449.33,453.67a116.17,116.17,0,0,0,55.52,0V414.13H449.33Z"
    //     transform="translate(-167.6 -120.78)"
    //     opacity="0.1"
    //   />
    //   <circle cx="309.5" cy="189.88" r="121.14" fill={theme.dark} />
    //   <circle cx="309.5" cy="217.64" r="116.09" fill={theme.skinColor} />
    //   <path
    //     d="M400.44,202.19c22.33-18.23,56.11-21.48,72.94-44.9,7-9.73,11.93-23.4,23.73-25.52l.35,24.9,37.79-3.88c-5.83,16.42,8.48,32.23,17.08,47.38a77.93,77.93,0,0,1,10.09,36.68c-13.12,7.88-29.39-.72-44-5.31-14.2-4.46-29.29-4.92-44.17-5.34-7.63-.22-15.35-.42-22.8,1.25-6.53,1.47-12.64,4.34-18.82,6.93-10.05,4.21-41.79,20.09-51.13,9.85C370.92,232.62,391.82,209.23,400.44,202.19Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill={theme.dark}
    //   />
    //   <path
    //     d="M406.75,280.2c6.16,3.73,13.4,5.2,20.53,6.18a180.86,180.86,0,0,0,88.11-9.9c4.6,11.66,15.83,19.67,27.77,23.48s24.69,4,37.22,4.15c2.76,0,5.72,0,8-1.53,5.58-3.77,2.88-12.4-.37-18.3L571.84,255c-4.78-8.66-9.7-17.5-17.1-24.06-9.28-8.21-21.6-12.06-33.75-14.49a190.34,190.34,0,0,0-86.64,2.89C404.13,227.47,365.31,255.12,406.75,280.2Z"
    //     transform="translate(-167.6 -120.78)"
    //     opacity="0.1"
    //   />
    //   <path
    //     d="M406.75,277.68c6.16,3.73,13.4,5.2,20.53,6.18a180.86,180.86,0,0,0,88.11-9.9c4.6,11.66,15.83,19.67,27.77,23.48s24.69,4,37.22,4.15c2.76,0,5.72,0,8-1.53,5.58-3.77,2.88-12.4-.37-18.3l-16.17-29.32c-4.78-8.66-9.7-17.5-17.1-24.06-9.28-8.21-21.6-12.06-33.75-14.49a190.34,190.34,0,0,0-86.64,2.89C404.13,224.94,365.31,252.59,406.75,277.68Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill={theme.dark}
    //   />
    //   <ellipse
    //     cx="424.33"
    //     cy="217.64"
    //     rx="10.1"
    //     ry="18.93"
    //     fill={theme.skinColor}
    //   />
    //   <ellipse
    //     cx="194.67"
    //     cy="217.64"
    //     rx="10.1"
    //     ry="18.93"
    //     fill={theme.skinColor}
    //   />
    //   <path
    //     d="M504.39,473.27S651.23,450.4,620.95,677.54l-17.66,65.11-50.48-2s32.81-75.71,12.62-126.19S504.39,473.27,504.39,473.27Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill={theme.accentColor}
    //   />
    //   <path
    //     d="M449.8,473.27S303,450.4,333.24,677.54l17.66,65.11,50.48-2s-32.81-75.71-12.62-126.19S449.8,473.27,449.8,473.27Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill={theme.accentColor}
    //   />
    //   <path
    //     d="M386.24,573.36s-10.1,78,7.57,100.71"
    //     transform="translate(-167.6 -120.78)"
    //     opacity="0.1"
    //   />
    //   <path
    //     d="M567.95,575.36s10.1,76-7.57,98.71"
    //     transform="translate(-167.6 -120.78)"
    //     opacity="0.1"
    //   />
    //   <circle cx="404.08" cy="619.68" r="27.76" fill={theme.skinColor} />
    //   <circle cx="214.91" cy="619.68" r="27.76" fill={theme.skinColor} />
    //   {/* -------------------------Har-Ko----------------------------- */}
    //   <g opacity="0.7">
    //     <rect
    //       x="218.04"
    //       y="461"
    //       width="182.77"
    //       height="162"
    //       rx="21.34"
    //       ry="21.34"
    //       fill="url(#2394db48-9094-48a1-80b4-38413320a0c3)"
    //     />
    //   </g>

    //   <rect
    //     x="221.42"
    //     y="464"
    //     width="176"
    //     height="156"
    //     rx="21.34"
    //     ry="21.34"
    //     fill={theme.imageDark}
    //   />

    //   <path
    //     d="M443.45,729.71V718a1.16,1.16,0,0,0-1.32-1.18,12.53,12.53,0,0,0-4.83,1.07v11.79H434V708h3.29v7.16a15.7,15.7,0,0,1,5.29-1.07c3,0,4.11,1.84,4.11,4.36v11.25h-3.26Zm9.41-7.08c.11,3.92.88,4.69,3.29,4.69a17,17,0,0,0,5.68-1.26l.55,2.47a15.37,15.37,0,0,1-6.44,1.56c-5.49,0-6.34-3-6.34-7.82a26.07,26.07,0,0,1,.82-7.21,18.82,18.82,0,0,1,6.61-1c4.5,0,5.87,2.5,5.87,6.86v1.67h-10Zm4.17-5.79a22.05,22.05,0,0,0-3.84.27,17.45,17.45,0,0,0-.36,3.24h6.86c0-2.28-.41-3.51-2.66-3.51Zm12,1.07v11.79h-3.29V716.43a19,19,0,0,1,7.63-2.11v2.74a14,14,0,0,0-4.33.85Zm13,12.18c-4.91,0-7.13-2.41-7.13-7.93,0-5.84,2.93-8.06,7.13-8.06,4.91,0,7.13,2.41,7.13,7.93,0,5.84-2.94,8.06-7.13,8.06Zm0-13.25c-2.52,0-3.92,1.45-3.92,5.32,0,4.22,1.18,5.16,3.92,5.16,2.52,0,3.92-1.43,3.92-5.29,0-4.22-1.18-5.18-3.92-5.18Zm23,12.86h-3.87a21.44,21.44,0,0,0-4.11-7h-1.73v7H492.1V708h3.29v12.45h1.54a20,20,0,0,0,3.87-6h3.7a25.74,25.74,0,0,1-4.69,6.64,46.5,46.5,0,0,1,5.29,8.58Zm6.17.38c-3,0-4.11-1.84-4.11-4.36V714.49h3.26v11.66a1.16,1.16,0,0,0,1.32,1.18,13.31,13.31,0,0,0,5-1.07V714.49H520v13.22A17.45,17.45,0,0,1,511.27,730.09Zm-1.45-27.61H444.18A10.16,10.16,0,0,1,434,692.32V606.07a10.16,10.16,0,0,1,10.16-10.16h65.63A10.17,10.17,0,0,1,520,606.07v86.25a10.16,10.16,0,0,1-10.17,10.16Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#6762a6"
    //   />
    //   <path
    //     d="M487.89,687.82V645.5s2.75-10.13-33.91,4.14c-.07.18-.07-39.14-.07-39.14l12-.07v25.19s33.54-13.21,33.54,10v42.18H487.89Zm6.83-62.15H482c4.57-5.59,8.71-15.17,8.71-15.17h13.14s-2.25,6.24-9.15,15.17Zm-40.59,62.07v-24.1l12.05,12.05-12.05,12.05Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#fff"
    //   />

    //   {/* <path
    //     d="M410.66,180.72h0q-7.67-2.62-15.45-4.88,1.29-5.25,2.38-10.56c11.7-56.9,4.05-102.74-22.06-117.83-25-14.48-66,.61-107.36,36.69q-6.1,5.34-11.95,11-3.9-3.76-8-7.36c-43.35-38.58-86.8-54.83-112.88-39.69-25,14.51-32.43,57.6-21.9,111.53q1.58,8,3.55,15.93c-6.15,1.75-12.09,3.62-17.77,5.6C48.46,198.9,16,226.73,16,255.59c0,29.82,34.84,59.72,87.77,77.85q6.44,2.19,13,4.07Q114.64,346,113,354.68c-10,53-2.2,95.07,22.75,109.49,25.77,14.89,69-.41,111.14-37.31q5-4.38,10-9.25,6.32,6.11,13,11.86c40.8,35.18,81.09,49.39,106,34.93,25.75-14.94,34.12-60.14,23.25-115.13q-1.25-6.3-2.88-12.86,4.56-1.35,8.93-2.79c55-18.27,90.83-47.81,90.83-78C496,226.62,462.5,198.61,410.66,180.72Zm-129-81.08c35.43-30.91,68.55-43.11,83.65-34.39h0c16.07,9.29,22.32,46.75,12.22,95.88q-1,4.8-2.16,9.57a487.83,487.83,0,0,0-64.18-10.16,481.27,481.27,0,0,0-40.57-50.75Q276,104.57,281.64,99.64ZM157.73,280.25q6.51,12.6,13.61,24.89,7.23,12.54,15.07,24.71a435.28,435.28,0,0,1-44.24-7.13C146.41,309,151.63,294.75,157.73,280.25Zm0-48.33c-6-14.19-11.08-28.15-15.25-41.63,13.7-3.07,28.3-5.58,43.52-7.48q-7.65,11.94-14.72,24.23T157.7,231.92Zm10.9,24.17q9.48-19.77,20.42-38.78h0q10.93-19,23.27-37.13c14.28-1.08,28.92-1.65,43.71-1.65s29.52.57,43.79,1.66q12.21,18.09,23.13,37t20.69,38.6Q334,275.63,323,294.73h0q-10.91,19-23,37.24c-14.25,1-29,1.55-44,1.55s-29.47-.47-43.46-1.38q-12.43-18.19-23.46-37.29T168.6,256.09ZM340.75,305q7.25-12.58,13.92-25.49h0a440.41,440.41,0,0,1,16.12,42.32A434.44,434.44,0,0,1,326,329.48Q333.62,317.39,340.75,305Zm13.72-73.07q-6.64-12.65-13.81-25h0q-7-12.18-14.59-24.06c15.31,1.94,30,4.52,43.77,7.67A439.89,439.89,0,0,1,354.47,231.93ZM256.23,124.48h0a439.75,439.75,0,0,1,28.25,34.18q-28.35-1.35-56.74,0C237.07,146.32,246.62,134.87,256.23,124.48ZM145.66,65.86c16.06-9.32,51.57,4,89,37.27,2.39,2.13,4.8,4.36,7.2,6.67A491.37,491.37,0,0,0,201,160.51a499.12,499.12,0,0,0-64.06,10q-1.83-7.36-3.3-14.82h0C124.59,109.46,130.58,74.61,145.66,65.86ZM122.25,317.71q-6-1.71-11.85-3.71c-23.4-8-42.73-18.44-56-29.81C42.52,274,36.5,263.83,36.5,255.59c0-17.51,26.06-39.85,69.52-55q8.19-2.85,16.52-5.21a493.54,493.54,0,0,0,23.4,60.75A502.46,502.46,0,0,0,122.25,317.71Zm111.13,93.67c-18.63,16.32-37.29,27.89-53.74,33.72h0c-14.78,5.23-26.55,5.38-33.66,1.27-15.14-8.75-21.44-42.54-12.85-87.86q1.53-8,3.5-16a480.85,480.85,0,0,0,64.69,9.39,501.2,501.2,0,0,0,41.2,51C239.54,405.83,236.49,408.65,233.38,411.38Zm23.42-23.22c-9.72-10.51-19.42-22.14-28.88-34.64q13.79.54,28.08.54c9.78,0,19.46-.21,29-.64A439.33,439.33,0,0,1,256.8,388.16Zm124.52,28.59c-2.86,15.44-8.61,25.74-15.72,29.86-15.13,8.78-47.48-2.63-82.36-32.72-4-3.44-8-7.13-12.07-11a484.54,484.54,0,0,0,40.23-51.2,477.84,477.84,0,0,0,65-10.05q1.47,5.94,2.6,11.64h0C383.81,377.58,384.5,399.56,381.32,416.75Zm17.4-102.64h0c-2.62.87-5.32,1.71-8.06,2.53a483.26,483.26,0,0,0-24.31-60.94,481.52,481.52,0,0,0,23.36-60.06c4.91,1.43,9.68,2.93,14.27,4.52,44.42,15.32,71.52,38,71.52,55.43C475.5,274.19,446.23,298.33,398.72,314.11Z"
    //     fill="#6762a6"
    //   />
    //   <path
    //     d="M256,298.55a43,43,0,1,0-42.86-43A42.91,42.91,0,0,0,256,298.55Z"
    //     fill="#fff"
    //   /> */}

    //   {/* -------------------------Har-Ko----------------------------- */}

    //   <g opacity="0.7">
    //     <rect
    //       x="682.04"
    //       y="387"
    //       width="182.77"
    //       height="162"
    //       rx="21.34"
    //       ry="21.34"
    //       fill="url(#894cb520-7283-4f65-92a7-edb841614828)"
    //     />
    //   </g>
    //   <rect
    //     x="685.42"
    //     y="390"
    //     width="176"
    //     height="156"
    //     rx="21.34"
    //     ry="21.34"
    //     fill={theme.imageDark}
    //   />
    //   <path
    //     d="M909.6,577a14.49,14.49,0,0,0,.53,4.26,25.64,25.64,0,0,0,1.53,3.45,2.08,2.08,0,0,1,.34,1.1,1.9,1.9,0,0,1-.91,1.44l-3,2a2.3,2.3,0,0,1-1.25.43,2.2,2.2,0,0,1-1.44-.67,14.82,14.82,0,0,1-1.72-2.25c-.48-.81-1-1.72-1.48-2.83a17.69,17.69,0,0,1-14.08,6.61c-4,0-7.23-1.15-9.58-3.45a13.51,13.51,0,0,1,.81-19.06c2.92-2.49,6.8-3.74,11.73-3.74a37.92,37.92,0,0,1,5.08.38c1.77.24,3.59.62,5.51,1.05v-3.5c0-3.64-.77-6.18-2.25-7.66s-4.12-2.2-7.81-2.2a21.79,21.79,0,0,0-5.17.62,38.16,38.16,0,0,0-5.17,1.63,13.74,13.74,0,0,1-1.68.62,2.94,2.94,0,0,1-.77.14c-.67,0-1-.48-1-1.48v-2.35a3,3,0,0,1,.34-1.68,3.59,3.59,0,0,1,1.34-1,27.57,27.57,0,0,1,6-2.16,29,29,0,0,1,7.47-.91c5.7,0,9.87,1.29,12.55,3.88s4,6.51,4,11.78V577Zm-19.44,7.28a15.52,15.52,0,0,0,4.93-.86,10.67,10.67,0,0,0,4.55-3.07,7.6,7.6,0,0,0,1.63-3.07,17.19,17.19,0,0,0,.48-4.17v-2a40,40,0,0,0-4.41-.81,36.09,36.09,0,0,0-4.5-.29c-3.21,0-5.56.62-7.14,1.92a6.84,6.84,0,0,0,4.45,12.36Zm38.46,5.17a2.67,2.67,0,0,1-1.82-.48,3.9,3.9,0,0,1-1-1.87l-11.25-37a8.39,8.39,0,0,1-.43-1.92,1.05,1.05,0,0,1,1.15-1.2h4.69a2.65,2.65,0,0,1,1.87.48,3.92,3.92,0,0,1,1,1.87l8,31.71,7.47-31.71a3.36,3.36,0,0,1,.91-1.87,3.29,3.29,0,0,1,1.92-.48h3.83a2.88,2.88,0,0,1,1.92.48,3.23,3.23,0,0,1,.91,1.87l7.57,32.09,8.29-32.09a4.11,4.11,0,0,1,1-1.87,3.12,3.12,0,0,1,1.87-.48h4.45a1.06,1.06,0,0,1,1.2,1.2,4.78,4.78,0,0,1-.1.77,6.81,6.81,0,0,1-.34,1.2l-11.54,37a3.67,3.67,0,0,1-1,1.87,3.06,3.06,0,0,1-1.82.48h-4.12a2.88,2.88,0,0,1-1.92-.48,3.4,3.4,0,0,1-.91-1.92l-7.42-30.89-7.38,30.84a3.74,3.74,0,0,1-.91,1.92,3,3,0,0,1-1.92.48Zm61.54,1.29a31.69,31.69,0,0,1-7.38-.86,21.79,21.79,0,0,1-5.51-1.92,3.45,3.45,0,0,1-1.48-1.34,3.38,3.38,0,0,1-.29-1.34v-2.44c0-1,.38-1.48,1.1-1.48a2.71,2.71,0,0,1,.86.14c.29.1.72.29,1.2.48a26.05,26.05,0,0,0,5.27,1.68,28.76,28.76,0,0,0,5.7.57,12.92,12.92,0,0,0,7-1.58,5.16,5.16,0,0,0,2.49-4.55,4.66,4.66,0,0,0-1.29-3.35,12,12,0,0,0-4.84-2.49L986,570.1c-3.5-1.1-6.08-2.73-7.66-4.89a11.41,11.41,0,0,1-2.39-6.94,10.66,10.66,0,0,1,1.29-5.32,12.31,12.31,0,0,1,3.45-3.93,15.2,15.2,0,0,1,5-2.49,20.87,20.87,0,0,1,6-.81,24,24,0,0,1,3.21.19c1.1.14,2.11.34,3.11.53s1.87.48,2.73.77a10.45,10.45,0,0,1,2,.86,4.14,4.14,0,0,1,1.44,1.2,2.58,2.58,0,0,1,.43,1.58v2.25c0,1-.38,1.53-1.1,1.53a5,5,0,0,1-1.82-.57,21.91,21.91,0,0,0-9.2-1.87,12.36,12.36,0,0,0-6.37,1.34,4.62,4.62,0,0,0-2.25,4.26,4.52,4.52,0,0,0,1.44,3.4,14.31,14.31,0,0,0,5.27,2.63l6.8,2.16c3.45,1.1,5.94,2.63,7.42,4.6a10.84,10.84,0,0,1,2.2,6.71,12.31,12.31,0,0,1-1.25,5.56,12.88,12.88,0,0,1-3.5,4.21,15.44,15.44,0,0,1-5.32,2.68,22.77,22.77,0,0,1-6.85,1Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#FFFFFF"
    //   />
    //   <path
    //     d="M999.21,614c-15.76,11.64-38.65,17.82-58.33,17.82a105.53,105.53,0,0,1-71.22-27.16c-1.48-1.34-.14-3.16,1.63-2.11a141.44,141.44,0,0,0,125.62,7.81c2.63-1.2,4.89,1.72,2.3,3.64Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#f90"
    //   />
    //   <path
    //     d="M1005.77,606.55c-2-2.59-13.31-1.25-18.44-.62-1.53.19-1.77-1.15-.38-2.16,9-6.32,23.8-4.5,25.53-2.39s-.48,17-8.91,24c-1.29,1.1-2.54.53-2-.91C1003.52,619.76,1007.78,609.08,1005.77,606.55Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#f90"
    //   />
    //   {/* -------------------------aws-Ko----------------------------- */}

    //   <g opacity="0.7">
    //     <rect
    //       x="573.04"
    //       y="115"
    //       width="182.77"
    //       height="162"
    //       rx="21.34"
    //       ry="21.34"
    //       fill="url(#43bfcda2-dcfb-4411-a28b-16db327cb63c)"
    //     />
    //   </g>
    //   <rect
    //     x="576.42"
    //     y="118"
    //     width="176"
    //     height="156"
    //     rx="21.34"
    //     ry="21.34"
    //     fill={theme.imageDark}
    //   />
    //   <path
    //     d="M807.53,357.41l-23.66-41,23.66-41h47.31l23.66,41-23.66,41H807.53"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#cac9c2"
    //   />
    //   <path
    //     d="M832,335.14a18.44,18.44,0,1,1,18.44-18.44A18.46,18.46,0,0,1,832,335.14"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#fff"
    //   />
    //   <path
    //     d="M869.08,261.72a10.13,10.13,0,0,0-7.91-4.57h-58.3a10.13,10.13,0,0,0-7.91,4.57l-17,29.5a9.69,9.69,0,0,0,1.06,5.35l11.53,19.71,20.58-35.56h65.06a9.5,9.5,0,0,1,4.76,1.5l-11.84-20.51"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#5072aa"
    //   />
    //   <path
    //     d="M778.67,289.94l-.75,1.29a9.7,9.7,0,0,0,1.06,5.35l11.53,19.71,6.13-10.6-18-15.76"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#4d6796"
    //   />
    //   <path
    //     d="M804.37,272.32a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56m58.3-3.56a3.29,3.29,0,1,1-6.59.08s0-.06,0-.08a3.29,3.29,0,0,1,6.59,0Z"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#fff"
    //   />
    //   <path
    //     d="M898.22,312.21l-17.31-30a9.5,9.5,0,0,0-4.76-1.5H852.7L873,316.49l-32.12,56.75a9.28,9.28,0,0,1-3.3,3.16h23.6a10.13,10.13,0,0,0,7.91-4.57l29.15-50.49a10.12,10.12,0,0,0,0-9.13"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#cc4232"
    //   />
    //   <path
    //     d="M881.7,283.58l-.78-1.35a9.49,9.49,0,0,0-4.76-1.5H852.7l6.11,10.76,22.89-7.92"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#b23f33"
    //   />
    //   <path
    //     d="M859.37,367.68a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56m27.69-47.42a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#fff"
    //   />
    //   <path
    //     d="M811.55,352.26,779,296.58a9.7,9.7,0,0,1-1.06-5.35l-12.11,21a10.13,10.13,0,0,0,0,9.13L795,371.83a10.13,10.13,0,0,0,7.91,4.56h34.69a9.28,9.28,0,0,0,3.3-3.16l11.88-21H811.55"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#ecb02a"
    //   />
    //   <path
    //     d="M835.59,376.4h2a9.27,9.27,0,0,0,3.3-3.16l11.88-21H840.14l-4.55,24.14"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#c79732"
    //   />
    //   <path
    //     d="M804.37,367.68a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56m-27.74-47.42a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56"
    //     transform="translate(-167.6 -120.78)"
    //     fill="#fff"
    //   />
    // </svg>
  );
}
